import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { Button } from "@progress/kendo-react-buttons";
import { SvgIcon } from "@progress/kendo-react-common";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns"
import { Checkbox, CheckboxChangeEvent, Slider, SliderChangeEvent, SliderLabel, Switch, TextBox, TextBoxChangeEvent, TextBoxProps } from "@progress/kendo-react-inputs";
import { useLocalization } from "@progress/kendo-react-intl";
import { Avatar } from "@progress/kendo-react-layout";
import { clockArrowRotateIcon, clockIcon, copyIcon, cssIcon, exclamationCircleIcon, globeIcon, playSmIcon, plusCircleIcon, plusIcon, saveIcon, sparklesIcon, trashIcon, userIcon } from "@progress/kendo-svg-icons";
import axios from "axios";
import React, { useCallback, useRef } from "react";
import { useEffect, useState } from "react";
import { AccessToken } from "../../../config/AccessToken";
import {
    TransformWrapper,
    TransformComponent,
    useControls
} from "react-zoom-pan-pinch";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";
import { loadingPanel } from "../../LoadingPanel";
import { AzureMapComponent } from "../../../pages/AzureMapComponent";
import { Dialog, Window } from "@progress/kendo-react-dialogs";

/**
 * ConfigRulesSubscription is a React functional component that manages and renders the configuration
 * for rule subscriptions. It provides UI and logic for creating, updating, and managing subscriptions
 * with various event types, actions, and conditions. It utilizes state management to handle user interactions
 * and API calls for fetching and manipulating data related to subscriptions, events, groups, zones, maps,
 * actions, and more. It also incorporates notifications and loading states to enhance user experience.
 */

export const ConfigRulesSubscription = () => {

    const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();

    const [loading, setLoading] = useState(false);

    const [saved, setSaved] = useState(false);
    const [updated, setUpdated] = useState(false);
    const [error, setError] = useState(false);
    const [removed, setRemoved] = useState(false);
    const [copiedMessage, setCopiedMessage] = useState(false);
    const [noZoneFoundMessage, setNoZoneFoundMessage] = useState(false);
    const [noFirstMapMessage, setNoFirstMapMessage] = useState(false);
    const [noSecondMapMessage, setNoSecondMapMessage] = useState(false);


    const [currentValue, setCurrentValue] = useState<any>([]);
    const [newSubscription, setNewSubscription] = useState<any>([]);

    //events
    const [eventsList, setEventsList] = useState<any>([]);
    const [eventName, setEventName] = useState<any>({name:''});
    const [eventDescription, setEventDescription] = useState<any>('');
    const [eventsSelected, setEventsSelected] = useState<boolean>(false);
    const [eventsIdSelected, setEventsIdSelected] = useState<any>(0);
    
    //groups
    const [groupsList, setGroupsList] = useState<any>([]);
    const [deviceGroupsSelected, setDeviceGroupsSelected] = useState<boolean>(false);
    const [deviceGroupIdSelected, setDeviceGroupIdSelected] = useState<any>('');
    const [groupNameSelected, setGroupNameSelected] = useState<any>('');
    const [deviceGroupNameSelected, setDeviceGroupNameSelected] = useState<any>('');
    const [groupIdSelected, setGroupIdSelected] = useState<any>(-1);
    
    //jobs
    const [jobsList, setJobsList] = useState<any>([]);
    const [jobSelected, setJobSelected] = useState<boolean>(false);
    const [jobNameSelected, setJobNameSelected] = useState<any>('');
    const [containJobs, setContainJobs] = useState<boolean>(false);
    const [jobIdSelected, setJobIdSelected] = useState<any>(-1);

    //timeslots
    const [isTimeslotSelected, isSetTimeSlotSelected] = useState<boolean>(false);
    const [timeSlotIdSelected, setTimeSlotIdSelected] = useState<any>(0);
    const [timeSlotList, setTimeSlotList] = useState<any>([]);
    const [timeSlotSelected, setTimeSlotSelected] = useState<any>();

    //timeout
    const [timeoutValue, setTimeoutValue] = useState<any>(0);
    const [timeoutSpam, setTimeoutSpam] = useState<TextBoxProps["value"]>(1000);
    
    //actions
    const [actionsList, setActionsList] = useState<any>([]);
    const [action, setAction] = useState<boolean>(false);
    
    const [commandsList, setCommandsList] = useState<any>([]);
    
    //map1 positions
    const [currentPositionX, setCurrentPositionX] = useState<any>(0);
    const [currentPositionY, setCurrentPositionY] = useState<any>(0);
    const [currentPositionElevation, setCurrentPositionElevation] = useState<any>(0);
    
    //map2 positions
    const [currentPositionMovedDeviceX, setCurrentPositionMovedDeviceX] = useState<any>(0);
    const [currentPositionMovedDeviceY, setCurrentPositionMovedDeviceY] = useState<any>(0);
    const [currentPositionMovedDeviceElevation, setCurrentPositionMovedDeviceElevation] = useState<any>(0);
    
    //zones
    const [zonesList, setZonesList] = useState<any>([]);
    const [zoneIdSelected, setZoneIdSelected] = useState<any>(-1);

    //devices number
    const [maxDevices, setMaxDevices] = useState<any>(0);
    const [minDevices, setMinDevices] = useState<any>(0);

    const [maxDistance, setMaxDistance] = useState<any>(0);
    
    const [actionIdSelected, setActionIdSelected] = useState<any>(0);
    const [actionSelected, setActionSelected] = useState<any>('');
    
    const [zoneSelected, setZoneSelected] = useState<any>({});
    const [isZoneSelected, setIsZoneSelected] = useState<boolean>(false);
    const [zoneNameSelected, setZoneNameSelected] = useState<any>({name:''});
    
    
    //battery
    const defaultBatteryValue = [0, 30, 50, 70, 100];
    const [batteryValue, setBatteryValue] = useState(50);
    
    //states
    const [firstMinStates, setFirstMinStates] = useState<TextBoxProps["value"]>('');
    const [firstMaxStates, setFirstMaxStates] = useState<TextBoxProps["value"]>('');
    const [secondMinStates, setSecondMinStates] = useState<TextBoxProps["value"]>('');
    const [secondMaxStates, setSecondMaxStates] = useState<TextBoxProps["value"]>('');
    const [propertyName, setPropertyName] = useState<TextBoxProps["value"]>('');
    const [stateDirectionSelected, setStateDirectionSelected] = useState<any>([]);
    const [directionNameSelected, setDirectionNameSelected] = useState<any>('');
    
    const [autoAck, setAutoAck] = useState<boolean | undefined>(false);
    const [autoAckTimeout, setAutoAckTimeout] = useState<TextBoxProps["value"]>(1000);
    
    const [actuatorSelected, setActuatorSelected] = useState<any>('');
    const [actuatorIdSelected, setActuatorIdSelected] = useState<any>([]);
    const [actuatorMessage, setActuatorMessage] = useState<boolean>(false);
    
    //channels
    const [channelNameSelected, setChannelNameSelected] = useState<any>('');
    const [multiChannelNameSelected, setMultiChannelNameSelected] = useState<any>({name:''});
    const [channelIdSelected, setChannelIdSelected] = useState<any>(0);
    const [channelSelectedList, setChannelSelectedList] = useState<any>([]);
    
    //multi-channels
    const [multiChannelSelectedList, setMultiChannelSelectedList] = useState<any>([]);
    const [delayChannel, setDelayChannel] = useState<any>([]);
    const [initialCondition, setInitialCondition] = useState<boolean | null | undefined>(false);
    const [initialChannel, setInitialChannel] = useState<any>('');
    const [initialChannelId, setInitialChannelId] = useState<any>(0);
    
    const [actionHandlersList, setActionHandlersList] = useState<any>(0);
    
    const [miscellaneous, setMiscellaneous] = useState<boolean>(false);
    
    const channels = {
        "data": [
            {
                "id": 0,
                "name": 'Channels 0',
                "checked": false
            },
            {
                "id": 1,
                "name": 'Channels 1',
                "checked": false
            },
            {
                "id": 2,
                "name": 'Channels 2',
                "checked": false
            },
            {
                "id": 3,
                "name": 'Channels 3',
                "checked": false
            }
        ]
    }
            
    const getMapList = async () => {
        
        //setLoading(true);
        
        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/map/full/list`, { headers })
            .then((res) => {
                const data = res?.data.data
                
                let mapsList: any = []
                let mapNames: any = []
                let mapImages: any = []
                data?.forEach((map: any) => {
                    mapsList.push(map)
                    mapNames.push(map.name)
                    mapImages.push(map.image)
                });
                setMapsList(mapsList)
                //setMapNamesList(mapNames)
                
                //localStorage.setItem("mapsList", JSON.stringify(mapsList))
                
            })
            .catch((error) => {
                if (error instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect(accessTokenRequest);
                }
                console.log(error);
                setLoading(false);
            });
        }
        
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
            }
        //setLoading(false);
    }
    
    //getMapsList
    useEffect(() => {
        getMapList()
    }, [])

    const [channelsDropdownList, setChannelsDropdownList] = useState<any>(channels.data);
    const [multiChannelsDropdownList, setMultiChannelsDropdownList] = useState<any>(channels.data);
    const [channelRelaysList, setChannelRelaysList] = useState<any>([]);
    const [multiChannelRelaysList, setMultiChannelRelaysList] = useState<any>([]);
    
    const [commandIdSelected, setCommandIdSelected] = useState<any>('');
    const [commandMessage, setCommandMessage] = useState<boolean>(false);
    
    const [defaultChannel, setDefaultChannel] = useState<any>('');
    
    const [apiList, setApiList] = useState<any>([]);
    const [apiIdSelected, setApiIdSelected] = useState<any>('');
    const [apiNameSelected, setApiNameSelected] = useState<any>('');
    const [apiMessage, setApiMessage] = useState<boolean>(false);
    
    const [mapsList, setMapsList] = useState<any>([]);
    const [firstMapSelected, setFirstMapSelected] = useState<any>('');
    const [mapNameSelected, setMapNameSelected] = useState<any>({name:''});
    const [secondMapSelected, setSecondMapSelected] = useState<any>('');
    const [currentMapCanvas, setCurrentMapCanvas] = useState<any>([]);
    const [currentSecondMapCanvas, setCurrentSecondMapCanvas] = useState<any>([]);
    const [currentZoneCanvas, setCurrentZoneCanvas] = useState<any>([]);
    const [showMap, setShowMap] = useState(false);
    const [mapClickableSelected, setMapClickableSelected] = useState<any>();
    const [isMapGeoreferenced, setIsMapGeoreferenced] = useState<any>(0);
    const [isSecondMapGeoreferenced, setIsSecondMapGeoreferenced] = useState<any>(0);

    const [mapNameMoved, setMapNameMoved] = useState<any>('');
    const [showMoveDeviceMap, setShowMapMoveDevice] = useState(false);
    const [mapMoveDeviceClickableSelected, setMapMoveDeviceClickableSelected] = useState<any>();

    const [checkedMultipleRelay, setCheckedMultipleRelay] = useState<any>([]);
    const [checkedInitialChannel, setCheckedInitialChannel] = useState<any>({checked:false});
    
    const [retrievedSubscription, setRetrievedSubscription] = useState<any>(false);
    const [subscriptionId, setSubscriptionId] = useState<any>();
    const [subscriptionToDelete, setSubscriptionToDelete] = useState<any>();
    
    const [alarmsFound, setAlarmsFound] = useState<any>(false);
    
    const [alarmConnected, setAlarmConnected] = useState<any>(0);
    const [showPopupDeleteSubscription, setShowPopupDeleteSubscription] = useState<any>(false);
    

    const firstMapCanvas: any = useRef()
    const firstPinCanvas: any = useRef()
    const secondMapCanvas: any = useRef()
    const secondPinCanvas: any = useRef()
    const zoneCanvas: any = useRef();
    let firstMapCtx = currentMapCanvas.length > 0 ? currentMapCanvas?.current?.getContext("2d") : firstMapCanvas?.current?.getContext("2d");    
    let secondMapCtx = currentSecondMapCanvas.length > 0  ? currentSecondMapCanvas?.current?.getContext("2d") : secondMapCanvas?.current?.getContext("2d");
    let zoneCtx = currentZoneCanvas ? currentZoneCanvas?.current?.getContext("2d") : zoneCanvas?.current?.getContext("2d");

    
    useEffect(() => {
        if (firstMapCanvas.current != null) {
            setCurrentMapCanvas(firstMapCanvas);
        }
        if (secondMapCanvas.current != null) {
            setCurrentSecondMapCanvas(secondMapCanvas);
        }
        if (zoneCanvas.current != null) {
            setCurrentZoneCanvas(zoneCanvas);
        }        
        if (firstMapCtx != null && firstMapCanvas.current != null) {
            renderFirstMap(firstMapSelected);
        }
        if (secondMapCtx != null && secondMapCanvas.current != null) {
            renderSecondMap(secondMapSelected);
        }
    }, []);

    const directionList = {
        "data": [
            {
                "id": 0,
                "name": 'Da 1 a 2',
                "value": '=>'
            },
            {
                "id": 1,
                "name": 'Da 2 a 1',
                "value": '<='
            },
            {
                "id": 2,
                "name": 'Entrambi',
                "value": '<=>'
            }
        ]
    }

    const refreshSubscription = () => {

        setEventsSelected(false)
        setIsZoneSelected(false)

        setRetrievedSubscription(false)

        let eventSelected: any = eventsList[0]
        setEventsIdSelected(eventSelected?.id)
        setEventName({name:eventSelected.name})
        setEventDescription({description:''})

        setTimeSlotSelected({range:''})
        
        setCurrentValue([...currentValue, eventSelected?.description]);
        
        setContainJobs(false)
        setDeviceGroupIdSelected(false)
        setGroupNameSelected(null)
        setDeviceGroupsSelected(false)
        isSetTimeSlotSelected(false)
        setFirstMapSelected(null)
        setSecondMapSelected(null)
        setMiscellaneous(false)
    }

    const onChangeEvent = (event: any) => {

        setEventsSelected(true)

        let eventSelected: any = event.value
        setEventsIdSelected(eventSelected?.id)
        setEventName({name:eventSelected.name})
        setEventDescription({description:eventSelected.description})

        if (eventSelected.index == -1) return;
        setCurrentValue([...currentValue, eventSelected.description]);
        setDeviceGroupsSelected(false)
        setGroupNameSelected(null)
        setJobSelected(false)
        setDeviceGroupNameSelected({name:''});
        setDeviceGroupsSelected(false)
        isSetTimeSlotSelected(false)
        setTimeSlotSelected({range:''})
        setFirstMapSelected(null)
        setSecondMapSelected(null)
        setMiscellaneous(false)
    }

    const onDeviceBelongToGroup = (event: DropDownListChangeEvent) => {
        isSetTimeSlotSelected(false)
        setTimeSlotSelected({range:''})
        setJobNameSelected(null)
        setJobSelected(false)
        setDeviceGroupsSelected(true)

        let currName:string = event.target.value.name
        let currId:string = event.target.value.id
        setDeviceGroupNameSelected({name:currName});
        setDeviceGroupIdSelected(currId);
        
        if(currId == '-1') return
        getJobsByGroup(currId)
    }

    const onJobSelected = (event: any) => {
        isSetTimeSlotSelected(false)
        setJobSelected(true)
        setJobNameSelected(event?.target?.value);

        jobsList.map((job: any) => {
            if(job != null){
                if (job.name === event?.target?.value) {
                    setJobIdSelected(job.id)
                }
            }
        })
    }

    useEffect(() => {
        if (jobsList != null) {
            setJobNameSelected(jobsList[0]?.name);
            setJobIdSelected(jobsList[0]?.id ?? -1);
            setJobSelected(true)
        }
    }, [jobsList]);

    const onTimeslotChange = (event: any) => {
        isSetTimeSlotSelected(true)
        setTimeSlotIdSelected(event?.target?.value?.id);
        setTimeSlotSelected({range:event?.target?.value?.range});
    }

    const onChangeFirstMinStates = useCallback((event: TextBoxChangeEvent) => {
        setFirstMinStates(event.target.value);
    }, []);

    const onChangeFirstMaxStates = useCallback((event: TextBoxChangeEvent) => {
        setFirstMaxStates(event.target.value);
    }, [])

    const onChangeSecondMinStates = useCallback((event: TextBoxChangeEvent) => {
        setSecondMinStates(event.target.value);
    }, []);

    const onChangeSecondMaxStates = useCallback((event: TextBoxChangeEvent) => {
        setSecondMaxStates(event.target.value);
    }, [])

    const onChangePropertyName = useCallback((event: TextBoxChangeEvent) => {
        setPropertyName(event.target.value);
    }, [])

    const onChangeStateDirection = (event: any) => {        
        setStateDirectionSelected(event.value.value)
        setDirectionNameSelected({name:event.value.name})
    }

    const onChangeZones = (event: any) => {                
        setZoneNameSelected({name:event.value.name})
        getMapByZoneId(event.value.id, event.value.name)      
    }

    const getMapByZoneId = async (zoneId: any, zoneNameSelected:any) => {
        
        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/map/zone/${zoneId}`, { headers })
                .then((res) => {
                    const data = res?.data?.data
                    setMapClickableSelected(data);

                    const isGeoreferenced = data?.georeferenced
                    setIsMapGeoreferenced(isGeoreferenced)
                    getZoneByMapId(data, zoneNameSelected, isGeoreferenced)                    

                }).catch((data) => {
                    setError(data?.message);
                    setTimeout(() => {
                        setError(false)
                    }, 3000);
                    setLoading(false);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
        setLoading(false);
    }
    const getZoneByMapId = async (dataMap: any, zoneNameSelected:any, isGeoreferenced:any) => {

        setLoading(true);
        
        let mapId:any = dataMap.id

        isGeoreferenced = isGeoreferenced == 1 ? true : false

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/zone/bymapid/${mapId}?isGeoreferenced=${isGeoreferenced}`, { headers })
                .then((res) => {
                    const data = res?.data?.data

                    let zoneSelected:any = data?.find((e: any) => e?.name === zoneNameSelected)

                    if(zoneSelected == undefined){
                        setNoZoneFoundMessage(true)
                        setTimeout(() => {
                            setNoZoneFoundMessage(false)
                            return
                        }, 3000);
                    }
                    setZoneSelected(zoneSelected)
                    setZoneNameSelected({name:zoneSelected?.name})
                    setZoneIdSelected(zoneSelected?.id)
                    setIsZoneSelected(true)
                    
                    renderFirstMap(dataMap, zoneSelected);
                    setLoading(false);
                }).catch((data) => {
                    setError(data?.message);
                    setLoading(false);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
        
    }

    const onChangeMaxDevices = (event: any) => {
        setMaxDevices(event?.value)
    }
    const onChangeMaxDistance = (event: any) => {
        setMaxDistance(event?.value)
    }

    const onChangeMinDevices = (event: any) => {
        setMinDevices(event?.value)
    }

    useEffect(() => {
        getSubscriptionList()
        getEventsType()
        getGroupsList()
        getZonesList()
        getActions()
        getCommands()
        getActionHandlers()
        getApiList()
    }, []);

    const getSubscriptionList = async () => {

        setLoading(true);
        
        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/subscription/list`, { headers })
                .then((res:any) => {
                    if(res.length == 0) return
                    const data = res?.data?.data
                    setNewSubscription(data);
                    setLoading(false);
                }).catch((data) => {
                    setError(data?.message);
                    setLoading(false);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const getEventsType = async () => {

        setLoading(true);
        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/subscription/eventType/list`, { headers })
                .then((res) => {
                    const data = res?.data?.data                    
                    setEventsList(data);
                    setLoading(false);
                }).catch((data) => {
                    setError(data?.message);
                    setLoading(false);
                });
        }

        setLoading(false);

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const getGroupsList = async () => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/group/list?enabled=true`, { headers })
                .then((res) => {
                    const data = res.data.data
                    let currGroupList: any = []
                    data?.forEach((group: any) => {
                        currGroupList.push({
                            id: group?.id,
                            name: group?.name,
                            color: group?.color
                        })
                    })

                    currGroupList.unshift({
                        id: -1, 
                        name:localizationService.toLanguageString('configuration.rules.subscription_all_groups', 'NOT FOUND')
                    })
                    setGroupsList([...groupsList, currGroupList]);

                    loadTimeslot();
                    setLoading(false);                    
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const getJobsByGroup = async (groupId: any) => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/group/${groupId}/jobs`, { headers })
                .then((res) => {
                    const data = res.data.data.filter((item:any) => item !== null);
                    if (data.length > 0) {
                        if(data[0] == null){
                            data.shift()
                        }
                        data.unshift({name:localizationService.toLanguageString('configuration.rules.subscription_all_jobs', 'NOT FOUND')})
                        setContainJobs(true)
                        isSetTimeSlotSelected(false)
                        setJobsList(data)
                    }else {
                        data.unshift({ id: -1, name: localizationService.toLanguageString('configuration.devices.no_job', 'NOT_FOUND') })
                        setContainJobs(false)
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    setError(error.response.data.errorMessage)
                    setTimeout(() => {
                        setError(false)
                    }, 5000);
                    
                    setLoading(false);
                });
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const getActionHandlers = async () => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/subscription/actionhandler/list`, { headers })
                .then((res) => {
                    const data = res.data.data
                    let currActionHandlerList: any = []
                    data?.forEach((action: any) => {
                        currActionHandlerList.push({
                            id: action?.id,
                            ipAddress: action?.ipAddress,
                            name: action?.name,
                            mac: action?.mac,
                            type: action?.type
                        })
                    })

                    setActionHandlersList(currActionHandlerList);
                    setLoading(false);                    
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }
    
    const getActionHandlersById = async (actionId:any) => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/subscription/actionhandler/${actionId}`, { headers })
                .then((res) => {
                    const data = res.data.data
                    setActuatorSelected({name:data.name})

                    setLoading(false);                    
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const getApiList = async () => {
        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/subscription/api/list`, { headers })
                .then((res) => {
                    const data = res.data.data
                    setApiList(data);

                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }

    }

    const loadTimeslot = async () => {

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/timeslot/list`, { headers })
                .then((res) => {
                    const data: any = res?.data?.data
                    let timeslotList: any = []
                    data?.forEach((timeslot: any) => {
                        if (timeslot?.startDate != null) {
                            const startDate = new Date(timeslot?.startDate);
                            //const hour = (startDate.getHours() < 10 ? '0' : '') + startDate.getHours();
                            //const minutes = (startDate.getMinutes() < 10 ? '0' : '') + startDate.getMinutes();
                            //timeslot.startDate = `${hour}:${minutes}`
                            timeslot.startDate = timeslot.startDate.match(/\d{2}:\d{2}/)[0]
                        }
                        if (timeslot?.endDate != null) {
                            const endDate = new Date(timeslot?.endDate);
                            //const hour = (endDate.getHours() < 10 ? '0' : '') + endDate.getHours();
                            //const minutes = (endDate.getMinutes() < 10 ? '0' : '') + endDate.getMinutes();
                            //timeslot.endDate = `${hour}:${minutes}`
                            timeslot.endDate = timeslot.endDate.match(/\d{2}:\d{2}/)[0]
                        }
                        timeslot.range = timeslot.startDate + ' - ' + timeslot.endDate
                        timeslotList.push(timeslot)
                    });
                    setTimeSlotList([...timeslotList]);

                }).catch((data) => {
                    setError(data?.message);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const getZonesList = async () => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/zone/list`, { headers })
                .then((res) => {
                    const data = res.data.data

                    let zonesList: any = []
                    let zoneSelected: any = []
                    let zoneNameSelected: any = []
                    // let mapImages:any=[]
                    data?.forEach((zone: any, id: any) => {
                        zonesList.push(zone)

                        zoneNameSelected.push(zone.name)
                        zoneSelected.push({
                            id: zone.id,
                            name: zone.name,
                            color: zone.color,
                            points: zone.points
                        })
                    });
                    // listZones.unshift("Select All")
                    // listZonesSelected.unshift("Select All")

                    setZonesList(zonesList)
                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                });
        }
    }

    const getActions = async () => {

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/subscription/action/list`, { headers })
                .then((res) => {
                    const data: any = res?.data?.data
                    let actionsList: any = []
                    data?.forEach((action: any) => {
                        actionsList.push(action)
                    });
                    setActionsList([...actionsList]);

                }).catch((data) => {
                    setError(data?.message);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const getCommands = async () => {

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/subscription/command/list`, { headers })
                .then((res) => {
                    const data: any = res?.data?.data
                    let commandsList: any = []
                    data?.forEach((commands: any) => {
                        commandsList.push(commands)
                    });
                    setCommandsList([...commandsList]);

                }).catch((data) => {
                    setError(data?.message);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const groupRender = (element: any, value: any) => {
        if (!value || deviceGroupNameSelected.name == '') {
            return element;
        }

        let color: any = []
        groupsList[0]?.map((group: any) => {
            color.push({
                name: group.name,
                color: group.color
            })
        })

        const children = [
            <span
                key={1}
                style={{
                    display: "inline-block",
                    border: `1px solid ${groupsList[0]?.find((group: any) => group?.name == value.name)?.color}`,
                    background: groupsList[0]?.find((group: any) => group?.name == value.name)?.color,
                    width: "18px",
                    height: "18px",
                    textAlign: "center",
                    overflow: "hidden",
                }}
            >
            </span>,
            <span key={2}>&nbsp; {value.name}</span>,
        ];
        return React.cloneElement(
            element,
            {
                ...element.props,
            },
            children
        );
    };
    
    const jobRender = (element: any, value: any) => {
        if (!value) {
            return element;
        }

        let color: any = []
        jobsList?.map((job: any) => {
            color.push({
                name: job?.name,
                color: job?.color
            })
        })

        const children = [
            <span
                key={1}
                style={{
                    display: "inline-block",
                    border: `1px solid ${jobsList?.find((job: any) => job?.name == value)?.color}`,
                    background: jobsList?.find((job: any) => job?.name == value)?.color,
                    width: "18px",
                    height: "18px",
                    textAlign: "center",
                    overflow: "hidden",
                }}
            >
            </span>,
            <span key={2}>&nbsp; {element.props.children}</span>,
        ];
        return React.cloneElement(
            element,
            {
                ...element.props,
            },
            children
        );
    };
    
    const timeslotRender = (element: any, value: any) => {
        if (!value) {
            return element;
        }

        const children = [            
            <span key={1}>&nbsp; {value.startDate} - {value.endDate}</span>,
        ];
        return React.cloneElement(
            element,
            {
                ...element.props,
            },
            children
        );
    };

    const zoneRender = (element: any, value: any) => {

        if (!value) {
            return element;
        }

        let color: any = []
        zonesList?.map((zone: any) => {
            color.push({
                name: zone.name,
                color: zone.color
            })
        })

        const children = [
            <span
                key={1}
                style={{
                    display: "inline-block",
                    border: `1px solid ${zonesList?.find((zone: any) => zone?.name == value.name)?.color}`,
                    background: zonesList?.find((zone: any) => zone?.name == value.name)?.color,
                    width: "18px",
                    height: "18px",
                    textAlign: "center",
                    overflow: "hidden",
                }}
            >
            </span>,
            <span key={2}>&nbsp; {value.name}</span>,
        ];
        return React.cloneElement(
            element,
            {
                ...element.props,
            },
            children
        );
    };

    const onChangeAction = (event: any) => {
        setAction(true)
        //setSelectedExecuteAction(event.target.value);

        setActionIdSelected(event.value.id)
        setActionSelected({action:event.value.action})

        setApiIdSelected(null)
        setApiNameSelected(null)
        setActuatorIdSelected(null)
        setActuatorSelected(null)
        setChannelNameSelected(null)
        setChannelIdSelected(null)
        setChannelsDropdownList(channels.data)
        setMultiChannelsDropdownList(channels.data)
        setChannelRelaysList([])
        setMultiChannelRelaysList([])
        setChannelSelectedList([])
        setMultiChannelSelectedList([])
        //setShowMap(false)
        setShowMapMoveDevice(false)
        setMiscellaneous(true)
        setCurrentPositionMovedDeviceX(0)
        setCurrentPositionMovedDeviceY(0)
        setCurrentPositionElevation(0)
    }

    const onChangeActuator = (event: any) => {
        let actuatorsSelected: any = actionHandlersList?.find((e: any) => e?.name === event.value.name)
        setActuatorIdSelected(actuatorsSelected?.id)
        setActuatorSelected({name:actuatorsSelected.name})
    }

    const onChangeChannel = (event: any) => {

        if (event.target.index == -1) return;

        const name = event.value.name

        setChannelNameSelected(name)
        setChannelIdSelected(event.value.id)

        //setChannelSelectedList(event.value)
        removeChannelRelaysFromDropdown(name)

        setChannelSelectedList([...channelSelectedList, { name: name, checked: false }])
        let newOrderedChannelRelaysList: any = [...channelSelectedList, { name: name, checked: false }]

        let orderedChannelRelaysList: any = newOrderedChannelRelaysList.sort((a: any, b: any) => a.name.localeCompare(b.name))

        setChannelRelaysList(orderedChannelRelaysList);
    }

    const onChangeMultipleChannel = (event: any) => {

        if (event.target.index == -1) return;

        const name = event.value.name
        const id = event.value.id

        setMultiChannelNameSelected({name:name})
        setChannelIdSelected(id)
        
        let updatedMultiChannelSelectedList: any = [...multiChannelSelectedList]
        updatedMultiChannelSelectedList.push({id: id, name: name, checked: false, delay: 0 })        
        setMultiChannelSelectedList(updatedMultiChannelSelectedList) 

        let newOrderedChannelRelaysList: any = [...multiChannelRelaysList, {id: id, name: name, checked: false, delay: 0}]

        let orderedChannelRelaysList: any = newOrderedChannelRelaysList.sort((a: any, b: any) => a.name.localeCompare(b))

        setMultiChannelRelaysList(orderedChannelRelaysList);
    }

    const onAddMultiChannel = (event: any) => {

        if (event.value == localizationService.toLanguageString('configuration.rules.subscription_channels', 'NOT FOUND')) return

        let currentChannelId: any = channelIdSelected 

        setChannelIdSelected(currentChannelId)

        if (currentChannelId == -1) return;
        
        let currentChannelValue: any = {id: channelIdSelected, name: multiChannelNameSelected.name, checked: false, delay: 0 }

        setMultiChannelSelectedList([...multiChannelSelectedList, currentChannelValue]) 

        let newOrderedChannelRelaysList: any = [...multiChannelRelaysList, currentChannelValue]

        let orderedChannelRelaysList: any = newOrderedChannelRelaysList.sort((a: any, b: any) => a.name.localeCompare(b))

        setMultiChannelRelaysList(orderedChannelRelaysList);
    }

    const removeChannelRelaysFromDropdown = (name: any) => {
        let currChannelList: any = channelsDropdownList.filter((channel: any) => channel.name !== name)

        let orderedChannelList: any = currChannelList?.sort((a: any, b: any) => a.name.localeCompare(b.name))
        setChannelsDropdownList(orderedChannelList)
    }

    const removeChannelRelays = (channelSelected: any, index: any) => {

        setChannelRelaysList((oldValues: any) => {
            return oldValues.filter((_: any, i: any) => i !== index)
        })

        setChannelSelectedList((oldValues: any) => {
            return oldValues.filter((channel: any, i: any) => channel.name !== channelSelected)
        })

        let channelDeleted = channels?.data?.find((channel: any) => channel.name === channelSelected)

        channelsDropdownList.push(channelDeleted);

        let currChannelList: any = channelsDropdownList?.sort((a: any, b: any) => {
            return a?.name?.localeCompare(b.name)
        })
        setDefaultChannel('')
        setChannelsDropdownList(currChannelList);
    }

    const removeMultiChannelRelays = (channelSelected: any, index: any) => {

        let newChannelRelaysList:any = multiChannelSelectedList.filter((_: any, i: any) =>  i !== index)

        setMultiChannelRelaysList(newChannelRelaysList)
        setMultiChannelSelectedList(newChannelRelaysList)

        setChannelNameSelected(channelSelected)    
        
        let checkedMultipleRelayList: any = [...newChannelRelaysList];
        setCheckedMultipleRelay(checkedMultipleRelayList)
    }

    const handleToggleChannelSelected = (event: any, channelSelected: any) => {

        channelSelectedList.map((channel: any) => {
            if (channel.name == channelSelected) {
                channel.checked = event.target.value
            }
        })

        setChannelSelectedList([...channelSelectedList])

        let orderedChannelRelaysList: any = channelSelectedList.sort((a: any, b: any) => a.name.localeCompare(b.name))
        setChannelRelaysList(orderedChannelRelaysList);
    };

    const handleToggleMultiChannelSelected = (event: any, channelSelected:any, index:any) => {        
      
        multiChannelSelectedList.map((channel: any, id:any) => {
            if (id == index) {
                channel.name = channelSelected.name
                channel.checked = event.target.value
            }
        })

        setMultiChannelSelectedList([...multiChannelSelectedList])
    };

    const handleChangeDelayChannel = (event: TextBoxChangeEvent, index:any) => {
        let currDelayValue:any = [...defaultChannel]
        currDelayValue.push(event.target.value)
        setDelayChannel(event.target.value);
        
        multiChannelSelectedList?.forEach((channel: any, id:any) => {
            if (id == index) {
                channel.delay = event.target.value
            }
        })
    };

    const handleInitialCondition = (event: CheckboxChangeEvent) => {
        setInitialCondition(event.value);
    };

    const onChangeInitialChannel = (event: any) => {
        if (event.value.id == -1) return;
        setInitialChannel({name:event.value.name});
        setInitialChannelId(event.value.id);
    }

    const handleToggleInitialChannelSelected = (event: any) => {
        setCheckedInitialChannel({checked:event.target.value});
    };

    const handleChangeTimeoutSpam = useCallback((event: TextBoxChangeEvent) => {
        setTimeoutSpam(event.target.value);
    }, []);

    const onChangeTimeout = (event: any) => {
        setTimeoutValue(event?.value)
    }

    const onChangeBatteryValue = (event: SliderChangeEvent) => {
        setBatteryValue(event.value);
    };

    const handleAutoAck = (event: CheckboxChangeEvent) => {
        setAutoAck(event.value);
    };

    const handleChangeAutoAckTimeout = useCallback((event: TextBoxChangeEvent) => {
        setAutoAckTimeout(event.target.value);
    }, []);

    const onChangeCommandType = (event: any) => {
        setCommandIdSelected(event.value.id)
    }

    const onChangeCallAPI = (event: any) => {
        let apiSelected: any = apiList?.find((api: any) => api.id == event.value.id)
        setApiIdSelected(apiSelected.id)
        setApiNameSelected({name:apiSelected.name});
    }

    const [prevPosX, setPrevPosX] = useState(0);
    const [prevPosY, setPrevPosY] = useState(0);
    
    const clickFirstPositionOnMap = (currMap: any, event: any) => {

        //draw red dot on click
        var context = firstPinCanvas.current?.getContext("2d");
        var posx = event.offsetX;
        var posy = event.offsetY;

        context.fillStyle = "#FF0000";
        context.beginPath();
        context.arc(posx, posy, 3, 0, 2 * Math.PI);
        context.fill();   

        setPrevPosX(posx)
        setPrevPosY(posy)
        
        //calculate coordinates on click
        let x:any = currMap?.botLeft.longitude + (currMap?.botRight?.longitude - currMap?.botLeft?.longitude) * event?.offsetX / firstPinCanvas?.width;
        let y:any = currMap?.topLeft?.latitude - (currMap?.botRight.latitude + (currMap?.topLeft?.latitude - currMap?.botLeft?.latitude) * event?.offsetY / firstPinCanvas?.height)
        const elevation = currMap?.altitude ?? 0;
        
        x = (Math.round(x * 100) / 100).toFixed(2);
        y = (Math.round(y * 100) / 100).toFixed(2);
        
        setCurrentPositionX(x)
        setCurrentPositionY(y)
        setCurrentPositionElevation(elevation)
    }

    const [secondPrevPosX, setSecondPrevPosX] = useState(0);
    const [secondPrevPosY, setSecondPrevPosY] = useState(0);

    const clickSecondPositionOnMap = (currMap: any, event?: any, subscriptionId?: any) => {

        var context = secondPinCanvas?.current?.getContext("2d") ?? document.querySelector('.secondPinCanvas');
        var posx = event?.offsetX
        var posy = event?.offsetY

        context.fillStyle = "#FF0000";
        context.beginPath();
        
        context.arc(posx, posy, 3, 0, 2 * Math.PI);
        context.fill();

        setSecondPrevPosX(posx)
        setSecondPrevPosY(posy)

        let x:any = currMap?.botLeft.longitude + (currMap?.botRight?.longitude - currMap?.botLeft?.longitude) * posx / secondPinCanvas?.width;
        let y:any = currMap?.topLeft?.latitude - (currMap?.botRight.latitude + (currMap?.topLeft?.latitude - currMap?.botLeft?.latitude) * posy / secondPinCanvas?.height)
        const elevation = currMap?.altitude ?? 0;

        x = (Math.round(x * 100) / 100).toFixed(2);
        y = (Math.round(y * 100) / 100).toFixed(2);

        setCurrentPositionMovedDeviceX(x)
        setCurrentPositionMovedDeviceY(y)
        setCurrentPositionMovedDeviceElevation(elevation)
    }

    const clearArc = (context: any, canvasMap:any) => {
        context.save();
        context.globalCompositeOperation = 'destination-out';
        context.beginPath();
        if(canvasMap == 'firstMapCanvas'){
            context.arc(prevPosX, prevPosY, 5, 0, 2 * Math.PI);            
        }else{
            context.arc(secondPrevPosX, secondPrevPosY, 5, 0, 2 * Math.PI);
        }
        context.fill();
        context.restore();
    }

    const firstCanvas: any = document.querySelector('.firstPinCanvas')
    firstCanvas?.addEventListener('mousedown', function (e: any) {

        var firstPinCtx = firstPinCanvas.current?.getContext("2d");
        clearArc(firstPinCtx, 'firstMapCanvas')

        let currMap: any = mapClickableSelected
        currMap != undefined ? clickFirstPositionOnMap(currMap, e) : null
    })

    const secondCanvas: any = document.querySelector('.secondPinCanvas')

    useEffect(() => {
        getSecondCanvas()
    })

    const getSecondCanvas = () => {
        return(
            secondCanvas?.addEventListener('mousedown', function (e: any) {
                var secondPinCtx = secondPinCanvas.current?.getContext("2d");
                clearArc(secondPinCtx, 'secondMapCanvas')
        
                let currMap: any = mapMoveDeviceClickableSelected
                //localStorage.setItem('mouseEventSecondCanvas', '{}')
                currMap != undefined ? clickSecondPositionOnMap(currMap, e, subscriptionId) : null
            })  
        )      
    }

    const getMapById = async (mapId: number, newMap?:any) => {

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/map/${mapId}`, { headers })
                .then((res) => {
                    const data = res.data.data

                    let infoMapSelected: any = []
                    let botLeft: any = []
                    let topLeft: any = []
                    let botRight: any = []
                    let topRight: any = []

                    infoMapSelected.push(data)
                    botLeft.push(data.botLeft)
                    topLeft.push(data.topLeft)
                    botRight.push(data.botRight)
                    topRight.push(data.topRight)

                    
                    if(!newMap){
                        renderSecondMap(data);
                        setMapMoveDeviceClickableSelected(data)
                        setShowMapMoveDevice(true)
                    }

                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const Controls = () => {
        const { zoomIn, zoomOut, resetTransform } = useControls();

        return (
            //<div className="k-button-subscription">
            <div className="k-button" style={{ border: 'none'}}>
                <button className="k-button-solid-primary" style={{ borderRadius: '0.25rem', width: '25px', margin: '5px', padding: '0px' }} onClick={() => zoomIn()}>+</button>
                <button className="k-button-solid-primary" style={{ borderRadius: '0.25rem', width: '25px', margin: '5px', padding: '0px' }} onClick={() => zoomOut()}>-</button>
                <button className="k-button-solid-primary" style={{ borderRadius: '0.25rem', width: '25px', margin: '5px', padding: '0px' }} onClick={() => resetTransform()}>x</button>
            </div>
        );
    };

    const renderFirstMap = (map: any, zoneSelected?:any) => {

        if (map?.georeferenced == 0 && firstMapCanvas?.current != null) {
            firstMapCtx?.clearRect(0, 0, firstMapCtx?.canvas.width, firstMapCtx?.canvas.height)

            const firstPinCtx = firstPinCanvas?.current?.getContext("2d");
            firstPinCtx?.clearRect(0, 0, firstPinCanvas?.width, firstPinCanvas?.height)

            zoneCtx = zoneCanvas?.current?.getContext("2d");
            zoneCtx?.clearRect(0, 0, zoneCanvas.current?.width, zoneCanvas.current?.height)

            let width: any = 0

            firstMapCtx = firstMapCanvas?.current?.getContext("2d");
            width = firstMapCtx?.canvas.parentElement.offsetWidth;

            let backgroundCanvas = new Image();

            localStorage.setItem('firstMapImage', map.image)
            let mapImageItem = localStorage.getItem('firstMapImage ' + map.image);
            if (mapImageItem !== null && JSON.parse(mapImageItem)) {
                mapImageItem = JSON.parse(mapImageItem);
                backgroundCanvas.src = `data:image/jpeg;base64, ${mapImageItem}`;
            } else {
                backgroundCanvas.src = `data:image/jpeg;base64, ${map.image}`;
            }
                          
            backgroundCanvas.onload = () => {
                let wImg = backgroundCanvas.width;
                let hImg = backgroundCanvas.height;
                let height = width * hImg / wImg;
                firstMapCanvas.height = firstPinCanvas.height = zoneCanvas.height = height = 300;
                firstMapCanvas.width = firstPinCanvas.width = zoneCanvas.width = width = 600;
                firstMapCanvas.current.style.backgroundImage = 'url(' + backgroundCanvas.src + ')';
                
                firstMapCtx?.drawImage(backgroundCanvas, 0, 0, firstMapCanvas.width, firstMapCanvas.height);

                if(zoneSelected != null && zoneCanvas?.current != null){                    
                    zoneCtx.beginPath();
                    zoneCtx.fillStyle = zoneSelected.color   
                    zoneCtx.moveTo(zoneCanvas.width * zoneSelected.points[0].longitude, zoneCanvas.height - zoneCanvas.height * zoneSelected.points[0].latitude);
                    zoneSelected?.points?.forEach((points: any) => {
                        zoneCtx.lineTo(zoneCanvas.width * points.longitude, zoneCanvas.height - zoneCanvas.height * points.latitude);
                    });
                    zoneCtx.globalAlpha = 0.8;
                    zoneCtx.fill();
                }
            };          
        } 
    }

    const renderSecondMap = (map: any) => {

        if (map?.georeferenced == 0 && secondMapCanvas?.current != null) {
            secondMapCtx?.clearRect(0, 0, secondMapCtx?.canvas.width, secondMapCtx?.canvas.height)

            const secondPinCtx = secondPinCanvas?.current?.getContext("2d");
            secondPinCtx?.clearRect(0, 0, secondPinCanvas?.width, secondPinCanvas?.height)

            let width: any = 0

            secondMapCtx = secondMapCanvas.current?.getContext("2d");
            width = secondMapCtx?.canvas.parentElement.offsetWidth;

            let backgroundCanvas = new Image();
            
            backgroundCanvas.onerror = (error) => { // Very important: Handle errors!
                console.error("Error loading image:", error);
            };

            localStorage.setItem('secondMapImage', map.image)
            let mapImageItem = localStorage.getItem('secondMapImage ' + map.image);
            if (mapImageItem !== null && JSON.parse(mapImageItem)) {
                mapImageItem = JSON.parse(mapImageItem);
                backgroundCanvas.src = `data:image/jpeg;base64, ${mapImageItem}`;
            } else {
                backgroundCanvas.src = `data:image/jpeg;base64, ${map.image}`;
            }

            //backgroundCanvas.src = mapImageItem ? `data:image/jpeg;base64, ${mapImageItem}` : `data:image/jpeg;base64, ${map.image}`;

            backgroundCanvas.onload = () => {
                let wImg = backgroundCanvas.width;
                let hImg = backgroundCanvas.height;
                let height = width * hImg / wImg;
                secondMapCanvas.height = secondPinCanvas.height = height;
                secondMapCanvas.width = secondPinCanvas.width = width;
                secondMapCtx?.drawImage(backgroundCanvas, 0, 0, secondMapCanvas.width, secondMapCanvas.height);
            };
        } 
    }

    const onChangeMap = (event?: any, mapIdRetrieved?: any, positionX?: any, positionY?: any, isGeoreferenced?:any) => {
        
        let mapName: any = event?.value?.name ?? event
        setMapNameSelected({name:mapName})

        let mapId: any = event?.value?.id ?? mapIdRetrieved

        const isMapGeoreferenced:any = event?.value?.georeferenced ?? isGeoreferenced

        setIsMapGeoreferenced(isMapGeoreferenced)

        //const listMaps: any = JSON.parse(localStorage.getItem('mapsList') || '')
        const listMaps: any = mapsList

        let mapSelected: any = null

        listMaps?.forEach((map: any) => {
            if (map.name == mapName || map.id == mapId) {
                renderFirstMap(map);
                getMapById(map.id)
                mapSelected = map
            }
        });
        setMapClickableSelected(mapSelected)
        setShowMap(true)

        if(mapIdRetrieved != null){
            //render position on first map
            var context = firstPinCanvas?.current?.getContext("2d");
            context.fillStyle = "#FF0000";
            context.beginPath();
            context.arc(positionX, positionY, 3, 0, 2 * Math.PI);
            context.fill(); 
        }
    }

    const onChangeMapMoveDevice = (event?: any, mapIdRetrieved?: any, positionX?: any, positionY?: any, isGeoreferenced?: any) => {

        if(!mapIdRetrieved){
            setCurrentPositionMovedDeviceX(0)
            setCurrentPositionMovedDeviceY(0)
            setCurrentPositionElevation(0)
        }   

        let mapName: any = event?.value?.name ?? event
        setMapNameMoved({name:mapName})

        let mapId: any = event?.value?.id ?? mapIdRetrieved

        const isSecondMapGeoreferenced:any = isGeoreferenced ?? event?.value?.georeferenced

        setIsSecondMapGeoreferenced(isSecondMapGeoreferenced)

        //const listMaps: any = JSON.parse(localStorage.getItem('mapsList') || '')
        const listMaps: any = mapsList

        let mapSelected: any = null

        listMaps?.forEach((map: any) => {
            if (map.name == mapName || map.id == mapId) {
                renderSecondMap(map);
                getMapById(map.id)
                mapSelected = map
            }
        });
        setMapMoveDeviceClickableSelected(mapSelected)
        setShowMapMoveDevice(true)

        //if(mapIdRetrieved != null){
        //    //render position on first map
        //    var context = secondPinCanvas?.current?.getContext("2d");
        //    context.fillStyle = "#FF0000";
        //    context.beginPath();
        //    context.arc(positionX, positionY, 3, 0, 2 * Math.PI);
        //    context.fill(); 
        //}

        //waitForElement('.secondPinCanvas', (element:any) => {
        //    clickSecondPositionOnMap(mapSelected, element, subscriptionId)
        //})
    }

    const onChangeGroup = (event: any) => {
        setGroupNameSelected({name:event.value.name});
    }

    const getMapByPosition = async (positionX:any, positionY:any, elevation:any) => {

        setLoading(true)

        const params:any = {
            longitude: positionX,
            latitude: positionY,
            elevation: elevation,
            orientation: 0
        }

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.post(`${SERVER_URL}/map/position`, params, {headers})
                .then((res) => {
                    const data = res.data.data

                    if(data == null){
                        setNoFirstMapMessage(true)    
                        setTimeout(() => {
                            setNoFirstMapMessage(false)
                        }, 3000);
                        return
                    }

                    setMapNameSelected({name:data.name})
                    setMapNameMoved({name:data.name})
                    setIsMapGeoreferenced(data.georeferenced)

                    onChangeMap(data.name, data.id, positionX, positionY, data.georeferenced);

                    setLoading(false)
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false)
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false)
                });
        }
    }
    
    const getSecondMapByPosition = async (positionX:any, positionY:any, elevation:any) => {

        setLoading(true)

        const params:any = {
            longitude: positionX,
            latitude: positionY,
            elevation: elevation,
            orientation: 0
        }

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.post(`${SERVER_URL}/map/position`, params, {headers})
                .then((res) => {
                    const data = res.data.data

                    if(data == null){
                        setNoSecondMapMessage(true)    
                        setTimeout(() => {
                            setNoSecondMapMessage(false)
                        }, 3000);
                        return
                    }

                    setMapNameSelected({name:data.name})
                    setMapNameMoved({name:data.name})
                    setIsMapGeoreferenced(data.georeferenced)

                    onChangeMapMoveDevice(data.name, data.id, positionX, positionY, data.georeferenced);

                    setLoading(false)
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false)
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false)
                });
        }
    }

    const saveNewSubscription = async () => {
        if (eventName == '') return

        setLoading(true);

        //console.log(channelIdSelected, channelNameSelected, channelStatusSelected);

        let channelsSelected: any = []
        if (actuatorIdSelected != null) {
            channelSelectedList.map((channel: any) => {
                channels?.data?.forEach((channelSelected: any) => {
                    if (channelSelected.name == channel.name) {
                        channelsSelected.push({ id: channelSelected.id, checked: channel.checked == true ? 1 : 0 });
                    }
                });
            })
        }

        let multipleRelayDrives:any = null
        if(actuatorSelected){
            multipleRelayDrives = 1
            
            if(initialCondition){
                let currCheckInitialChannel:any = checkedInitialChannel ? 1 : 0
                multipleRelayDrives += '|$' + initialChannelId + ',' + currCheckInitialChannel
            }

            if(retrievedSubscription){
                if(multiChannelSelectedList.length > 0){
                    multipleRelayDrives += '|' + multiChannelSelectedList.map((channel: any) => {
                        let channelId:any = channel.name == 'Channels 0' ? 0 : channel.name == 'Channels 1' ? 1 : channel.name == 'Channels 2' ? 2 : 3        
                        let checked = (channel.checked) ? 1 : 0           
                        return (channelId + ',' + checked + ',' + channel.delay)
                    }).join('|')
                }
            }else{
                if(multiChannelSelectedList.length > 0){
                    multipleRelayDrives += '|' + multiChannelSelectedList.map((channel: any) => {
                        let checked = checkedMultipleRelay?.find((checked: any) => checked.id == channel.id)
                        checked = (checked != undefined && checked.value) ? 1 : 0           
                        return (channel.id + ',' + checked + ',' + channel.delay)
                    }).join('|')
                }
            }
        }


        let param1Value: any, param2Value: any, param3Value: any, param4Value: any, param5Value: any;
        switch (eventsIdSelected) {
            case 1:
            case 2:
                param1Value = zoneIdSelected?.toString() ?? '-1'
                break;
            case 4:
                param1Value = timeoutValue?.toString()
                break;
            case 5:
                param1Value = maxDistance?.toString()
                break;
            case 12:
                param1Value = batteryValue?.toString()
                break;
            case 25:
                param1Value = zoneIdSelected?.toString()
                param2Value = maxDevices?.toString()
                break;
            case 26:
                param1Value = zoneIdSelected?.toString()
                param2Value = minDevices?.toString()
                break;
            case 32:
            case 33:
                param1Value = currentPositionX.toString()
                param2Value = currentPositionY.toString()
                param3Value = currentPositionElevation.toString()
                break;
            case 37:
                param1Value = zoneIdSelected.toString()
                break;
            case 40:
                param1Value = zoneIdSelected.toString()
                break;
            case 49:
                param1Value = firstMinStates + '|' + firstMaxStates
                param2Value = secondMinStates + '|' + secondMaxStates
                param3Value = stateDirectionSelected ?? '<=>'
                param4Value = propertyName
                break;
            default:
                break;
        }

        switch (actionIdSelected) {
            case 3: //RELAY_DRIVE
                param5Value = actuatorIdSelected + channelsSelected.map((channel: any) => {
                    return ('|' + channel.id + ',' + channel.checked)
                }).join('')
                break;
            case 4: //SEND_COMMAND
                param5Value = commandIdSelected.toString() ?? setCommandMessage(true)
                break;
            case 8: //MULTIPLE_RELAY_DRIVES
                param5Value = actuatorSelected == null ? setActuatorMessage(true) : multipleRelayDrives
                break;
            case 9: //API
                param5Value = apiIdSelected.toString() ?? setApiMessage(true)
                break;
            case 10: //MOVE_DEVICE
                param5Value = `[${currentPositionMovedDeviceX}|${currentPositionMovedDeviceY}|${currentPositionMovedDeviceElevation}]`
                break;
            case 11: //GROUP_CHANGE
                param5Value = groupIdSelected.toString()
                break;
            default:
                break;
        }

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params = {
                eventTypeId: eventsIdSelected ?? null,
                jobId: jobIdSelected ?? null,
                groupId: deviceGroupIdSelected ?? null,
                timeSlotId: timeSlotIdSelected ?? null,
                actionId: actionIdSelected ?? null,
                param1: param1Value ?? null,
                param2: param2Value ?? null,
                param3: param3Value ?? null,
                param4: param4Value ?? null,
                param5: param5Value ?? null,
                deviceTypeId: 0, //only if When: "detected a custom device event" - not present now
                autoAckTimeout: autoAck ? autoAckTimeout : -1,
                spamTimeout: timeoutSpam ?? null
            }
            axios.post(`${SERVER_URL}/subscription`, params, { headers })
                .then(() => {

                    getSubscriptionList();

                    setSaved(true)    
                    setTimeout(() => {
                        setSaved(false)
                    }, 3000);

                    refreshSubscription()
                    
                    setLoading(false);
                }).catch((data) => {
                    setError(data?.message);
                    setTimeout(() => {
                        setError(false)
                    }, 3000);
                    setLoading(false);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }

        if (!apiMessage) {
            setTimeout(() => {
                setApiMessage(false);
            }, 3000);
        }
        else if (!commandMessage) {
            setTimeout(() => {
                setCommandMessage(false);
            }, 3000);
        }
        else if (!actuatorMessage) {
            setTimeout(() => {
                setActuatorMessage(false);
            }, 3000);
        }

        if (!saved) {
            setTimeout(() => {
                setSaved(false);
            }, 3000);
        }

        setRetrievedSubscription(false);
    }

    const updateSubscription = async (subscriptionId:any) => {
        if (eventName == '') return

        setLoading(true);

        let channelsSelected: any = []
        if (actuatorIdSelected != null) {
            channelSelectedList.map((channel: any) => {
                channels?.data?.forEach((channelSelected: any) => {
                    if (channelSelected.name == channel.name) {
                        channelsSelected.push({ id: channelSelected.id, checked: channel.checked == true ? 1 : 0 });
                    }
                });
            })
        }

        let multipleRelayDrives:any = null
        if(actuatorSelected){
            multipleRelayDrives = 1
            
            if(initialCondition){
                let currCheckInitialChannel:any = checkedInitialChannel ? 1 : 0
                multipleRelayDrives += '|$' + initialChannelId + ',' + currCheckInitialChannel
            }

            if(retrievedSubscription){
                if(multiChannelSelectedList.length > 0){
                    multipleRelayDrives += '|' + multiChannelSelectedList.map((channel: any) => {
                        let channelId:any = channel.name == 'Channels 0' ? 0 : channel.name == 'Channels 1' ? 1 : channel.name == 'Channels 2' ? 2 : 3        
                        let checked = (channel.checked) ? 1 : 0           
                        return (channelId + ',' + checked + ',' + channel.delay)
                    }).join('|')
                }
            }else{
                if(multiChannelSelectedList.length > 0){
                    multipleRelayDrives += '|' + multiChannelSelectedList.map((channel: any) => {
                        let checked = checkedMultipleRelay?.find((checked: any) => checked.id == channel.id)
                        checked = (checked != undefined && checked.value) ? 1 : 0           
                        return (channel.id + ',' + checked + ',' + channel.delay)
                    }).join('|')
                }
            }
        }


        let param1Value: any, param2Value: any, param3Value: any, param4Value: any, param5Value: any;
        switch (eventsIdSelected) {
            case 1:
            case 2:
                param1Value = zoneIdSelected?.toString()
                break;
            case 4:
                param1Value = timeoutValue?.toString()
                break;
            case 5:
                param1Value = maxDistance?.toString()
                break;
            case 12:
                param1Value = batteryValue?.toString()
                break;
            case 25:
                param1Value = zoneIdSelected?.toString()
                param2Value = maxDevices?.toString()
                break;
            case 26:
                param1Value = zoneIdSelected?.toString()
                param2Value = minDevices?.toString()
                break;
            case 32:
            case 33:
                param1Value = currentPositionX?.toString()
                param2Value = currentPositionY?.toString()
                param3Value = currentPositionElevation?.toString()
                break;
            case 37:
                param1Value = zoneIdSelected?.toString()
                break;
            case 40:
                param1Value = zoneIdSelected?.toString()
                break;
            case 49:
                param1Value = firstMinStates + '|' + firstMaxStates
                param2Value = secondMinStates + '|' + secondMaxStates
                param3Value = stateDirectionSelected ?? '<=>'
                param4Value = propertyName
                break;
            default:
                break;
        }

        switch (actionIdSelected) {
            case 3: //RELAY_DRIVE
                param5Value = actuatorIdSelected + channelsSelected.map((channel: any) => {
                    return ('|' + channel.id + ',' + channel.checked)
                }).join('')
                break;
            case 4: //SEND_COMMAND
                param5Value = commandIdSelected.toString() ?? setCommandMessage(true)
                break;
            case 8: //MULTIPLE_RELAY_DRIVES
                param5Value = actuatorSelected == null ? setActuatorMessage(true) : multipleRelayDrives
                break;
            case 9: //API
                param5Value = apiIdSelected.toString() ?? setApiMessage(true)
                break;
            case 10: //MOVE_DEVICE
                param5Value = `[${currentPositionMovedDeviceX}|${currentPositionMovedDeviceY}|${currentPositionMovedDeviceElevation}]`
                break;
            case 11: //GROUP_CHANGE
                param5Value = groupIdSelected.toString()
                break;
            default:
                break;
        }

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params = {
                eventTypeId: eventsIdSelected ?? null,
                jobId: jobIdSelected ?? null,
                groupId: deviceGroupIdSelected ?? null,
                timeSlotId: timeSlotIdSelected ?? null,
                actionId: actionIdSelected ?? null,
                param1: param1Value ?? null,
                param2: param2Value ?? null,
                param3: param3Value ?? null,
                param4: param4Value ?? null,
                param5: param5Value ?? null,
                deviceTypeId: 0, //only if When: "detected a custom device event" - not present now
                autoAckTimeout: autoAck ? autoAckTimeout : -1,
                spamTimeout: timeoutSpam ?? null
            }
            axios.put(`${SERVER_URL}/subscription/${subscriptionId}`, params, { headers })
                .then(() => {

                    getSubscriptionList();

                    setUpdated(true)    

                    setTimeout(() => {
                        setUpdated(false)
                    }, 3000);

                    refreshSubscription()
                    
                    setLoading(false);
                }).catch((data) => {
                    setError(data?.message);
                    setTimeout(() => {
                        setError(false)
                    }, 3000);
                    setLoading(false);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }

        if (!apiMessage) {
            setTimeout(() => {
                setApiMessage(false);
            }, 3000);
        }
        else if (!commandMessage) {
            setTimeout(() => {
                setCommandMessage(false);
            }, 3000);
        }
        else if (!actuatorMessage) {
            setTimeout(() => {
                setActuatorMessage(false);
            }, 3000);
        }

        if (!saved) {
            setTimeout(() => {
                setUpdated(false);
            }, 3000);
        }

        setRetrievedSubscription(false);
    }

    const removingSubscription = async (subscription:any) => {
                
        setLoading(true);

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };

            axios.get(`${SERVER_URL}/alarm/count/${subscription.id}`, { headers })
                .then((res:any) => {
                    const data:any = res.data.data.alarmCount
                    if(data > 0){
                        setShowPopupDeleteSubscription(true)
                        setAlarmConnected(data)
                        setSubscriptionId(subscription.id)
                        setSubscriptionToDelete(subscription)
                    }else{
                       removeSubscription(subscription) 
                    }
                    setLoading(false);
                }).catch(() => {                    
                    setLoading(false);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }

        if (removed) {
            setTimeout(() => {
                setRemoved(false);
            }, 3000);
        }

        if (error) {
            setTimeout(() => {
                setError(false);
            }, 3000);
        }
    }

    const removeSubscription = async (subscription:any) => {
                
        setLoading(true);

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };

            axios.delete(`${SERVER_URL}/subscription/${subscription.id}`, { headers })
                .then(() => {
                    setNewSubscription((oldValues: any) => {
                        return oldValues.filter((item: any) => item.id !== subscription.id);
                    });
                    setRemoved(true);
                    setShowPopupDeleteSubscription(false)                    
                    if (!removed) {
                        setTimeout(() => {
                            setRemoved(false);
                        }, 3000);
                    }
                    setLoading(false);
                }).catch((data) => {
                    if(data?.response?.data?.errorMessage == 'Error executing the API: Alarms were found for this subscription'){
                        setAlarmsFound(true);
                    }
                    setLoading(false);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }

        if (removed) {
            setTimeout(() => {
                setRemoved(false);
            }, 3000);
        }

        if (error) {
            setTimeout(() => {
                setError(false);
            }, 3000);
        }
    }

    const copySubscription = async(subscription: any) => {

        setLoading(true);
        
        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            
            axios.post(`${SERVER_URL}/subscription/${subscription.id}/copy`, null, { headers })
                .then(() => {

                    setCopiedMessage(true)    
                    getSubscriptionList();

                    setTimeout(() => {
                        setCopiedMessage(false)
                    }, 3000);
                    
                    setLoading(false);
                }).catch((data) => {
                    setError(data?.message);
                    setLoading(false);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }

    }

    const itemRefs:any = useRef([]);

    const loadSubscriptionSelected = async (subscription: any) => {

        setLoading(true);

        setSubscriptionId(subscription.id);
        setRetrievedSubscription(true);

        setIsZoneSelected(true)

        // Access the clicked element's ref
        itemRefs?.current?.forEach((element:any, i:any) => {
            if (i == subscription.id) {
              itemRefs.current[i].style.background = '#198792' ;   
              itemRefs.current[i].style.borderRadius = '10px' ;   
              itemRefs.current[i].style.color = '#ffffff' ;   
            }else{
                itemRefs?.current[i]?.style?.removeProperty('background')
                itemRefs?.current[i]?.style?.removeProperty('color')
            }
        });
        

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            
            axios.get(`${SERVER_URL}/subscription/${subscription.id}/`, { headers })
                .then((response:any) => {
                    
                    {/*events*/}
                    setEventDescription({description:subscription.description});
                    setEventsSelected(true);

                    {/* device belong to group*/}
                    const groupId = subscription.groupId;
                    const group = groupsList[0]?.find((g: any) => g.id == groupId);
                    setDeviceGroupsSelected(true);
                    setDeviceGroupIdSelected(groupId);
                    setDeviceGroupNameSelected({name:group.name});

                    {/* if group with job */}
                    if(jobSelected){
                        setJobSelected(true);
                        setJobIdSelected(subscription.jobId);
                    }

                    {/*timeslots*/}
                    isSetTimeSlotSelected(true);
                    setTimeSlotIdSelected(subscription.timeslot.id);

                    let timeslotList: any = []
                    if (subscription.timeslot?.startDate != null) {
                        const timeRegex = /([0-2][0-3]):([0-5][0-9]):([0-5][0-9])/; 
                        const match = subscription.timeslot?.endDate.match(timeRegex);

                        if (match) {
                            timeslotList.startDate = `${match[1]}:${match[2]}`; 
                        } else {
                            return null;
                        }  
                    }

                    if (subscription.timeslot?.endDate != null) {
                        const timeRegex = /([0-2][0-3]):([0-5][0-9]):([0-5][0-9])/; 
                        const match = subscription.timeslot?.endDate.match(timeRegex);

                        if (match) {
                            timeslotList.endDate = `${match[1]}:${match[2]}`; 
                        } else {
                            return null;
                        }                     
                    }

                    timeslotList = timeslotList.startDate + ' - ' + timeslotList.endDate
                    setTimeSlotSelected({range:timeslotList});

                    {/*device out of range*/}
                    if(subscription.eventTypeId == 4){
                        setEventsIdSelected(4);
                        setTimeoutValue(subscription.parameter1);
                    }

                    {/*approching device*/}
                    if(subscription.eventTypeId == 5){
                        setEventsIdSelected(5);
                        setMaxDistance(subscription.parameter1);
                    }

                    {/*device battery low*/}
                    if(subscription.eventTypeId == 12){
                        setEventsIdSelected(12);
                        setBatteryValue(subscription.parameter1);
                    }

                    setEventsIdSelected(subscription.eventTypeId);
                    
                    {/*zones*/}
                    const currentEventId = subscription.eventTypeId;
                    if(currentEventId != 7 && currentEventId != 8 && currentEventId != 4 && currentEventId != 5 && currentEventId != 12 && currentEventId != 32 && currentEventId != 33 && currentEventId != 49){
                        let zoneIdSelected = subscription.parameter1;
                        if(zoneIdSelected != null && zoneIdSelected != '-1'){
                            let zoneSelected = zonesList?.find((z: any) => z.id == zoneIdSelected);    
                            getMapByZoneId(zoneIdSelected, zoneSelected.name)
                        }
                    }

                    //min/max devices
                    if(subscription.eventTypeId == 25){
                        setEventsIdSelected(25);
                        const maxDevice:string = subscription.parameter2.split("|")
                        setMaxDevices(maxDevice[1]);
                    }
                    else if(subscription.eventTypeId == 26){
                        setEventsIdSelected(26);
                        const minDevice:string = subscription.parameter2.split("|")
                        setMinDevices(minDevice[0]);
                    }
                    
                    {/*device close/far to/from position*/}
                    if(subscription.eventTypeId == 32 ){
                        setEventsIdSelected(32);
                        setCurrentPositionX(subscription.parameter1);
                        setCurrentPositionY(subscription.parameter2);
                        setCurrentPositionElevation(subscription.parameter3);

                        setShowMap(true)

                        //recuperare mappa dalle coordinate
                        getMapByPosition(subscription.parameter1, subscription.parameter2, subscription.parameter3);

                    }
                    else if(subscription.eventTypeId == 33){
                        setEventsIdSelected(33);
                        setCurrentPositionX(subscription.parameter1);
                        setCurrentPositionY(subscription.parameter2);
                        setCurrentPositionElevation(subscription.parameter3);

                        setShowMap(true)

                        //recuperare mappa dalle coordinate
                        getMapByPosition(subscription.parameter1, subscription.parameter2, subscription.parameter3);
                    }
                    
                    {/*custom info value changed*/}
                    if(subscription.eventTypeId == 49){
                        setEventsIdSelected(49);

                        const firstMinStates:string = subscription.parameter1.split("|")[0];
                        const firstMaxStates:string = subscription.parameter1.split("|")[1];
                        const secondMinStates:string = subscription.parameter2.split("|")[0];
                        const secondMaxStates:string = subscription.parameter2.split("|")[1];
                        setFirstMinStates(firstMinStates);
                        setFirstMaxStates(firstMaxStates);
                        setSecondMinStates(secondMinStates);
                        setSecondMaxStates(secondMaxStates);
                        setPropertyName(subscription.parameter4);                        
                        setStateDirectionSelected(subscription.parameter3);
                        const directionNameSelected = directionList?.data?.find((d: any) => d.value == subscription.parameter3);
                        setDirectionNameSelected(directionNameSelected);
                    }

                    setActionIdSelected(subscription.action);
                    const actionSelected = actionsList?.find((a: any) => a.id == subscription.action);
                    setActionSelected({action:actionSelected.action});

                    setAction(true)
                    setMiscellaneous(true)


                    /*actuators & relay channels*/
                    if(subscription.action == 3){                        
                        const parameter5 = subscription.parameter5.split("|");

                        const actuatorSelected = parameter5[0]
                        getActionHandlersById(actuatorSelected)
                        
                        parameter5.shift();

                        const newChannelRelaysList = parameter5.map((channel:any) => {
                            const [name, checked] = channel.split(",");
                            return {
                                name: `Channels ${name}`, 
                                checked: checked === "1" ? true : false
                            };
                        });

                        // Remove items from array2 that are included in array1
                        const newChannelsDropdownList = channelsDropdownList.filter((item2:any) => 
                            !newChannelRelaysList.some((item1:any) => item1.name === item2.name)
                        );

                        setChannelsDropdownList(newChannelsDropdownList);
                        setChannelSelectedList(newChannelRelaysList);
                        setChannelRelaysList(newChannelRelaysList);
                    }
                    
                    //actuators & channels relay multi
                    if(subscription.action == 8){

                        const parameter5 = subscription.parameter5.split("|");

                        const actuatorSelected = parameter5[0]

                        getActionHandlersById(actuatorSelected)

                        // Find the part containing '$' the 'initialCondition'
                        const initialCondition = parameter5?.find((part:any) => part.includes('$'));

                        if(initialCondition != null){
                            switch (initialCondition.split('$')[1][0]) {
                                case '0':
                                    setInitialChannel({name: 'Channel 0'});
                                    break;
                                case '1':
                                    setInitialChannel({name: 'Channel 1'});
                                    break;
                                case '2':
                                    setInitialChannel({name: 'Channel 2'});
                                    break;
                                case '3':
                                    setInitialChannel({name: 'Channel 3'});
                                    break;
                                default:
                                    break;
                            }

                            if(initialCondition.split('$')[1][2] == '0'){
                                setInitialCondition(false);
                                setCheckedInitialChannel({checked:false});
                            }else{
                                setInitialCondition(true);
                                setCheckedInitialChannel({checked:true});
                            }
                        }
                        
                        parameter5.shift();

                        const filteredParts = parameter5.filter((part:any) => !part.includes('$'));
    
                        const newChannelRelaysList = filteredParts.map((channel:any, index:any) => {
                            const [name, checked, delay] = channel.split(",");
                            return {
                                id: index,
                                name: `Channels ${name}`, 
                                checked: checked === "1" ? true : false,
                                delay: delay
                            };
                        });
        
                        setMultiChannelSelectedList(newChannelRelaysList)   
                        setMultiChannelRelaysList(newChannelRelaysList);                        
                    }
                    
                    // subscription api
                    if(subscription.action == 9){
                        const apiSelected = apiList?.find((a: any) => a.id == subscription.parameter5);
                        setApiNameSelected({name:apiSelected.name});
                    }
                    
                    // device moved to map
                    if(subscription.action == 10){
                        const coordinates:any= subscription.parameter5.split('|')

                        setCurrentPositionMovedDeviceX(coordinates[0].substr(1));
                        setCurrentPositionMovedDeviceY(coordinates[1]);
                        setCurrentPositionMovedDeviceElevation(coordinates[2].slice(0, -1));

                        getMapById(response.data.data.mapId, true);
                        
                        getSecondMapByPosition(coordinates[0].substr(1), coordinates[1], coordinates[2].slice(0, -1));       
                    }
                    
                    // change group
                    if(subscription.action == 11){
                        const groupIdSelected:any = subscription.parameter5
                        const groupsListSelected = groupsList[0]?.find((a: any) => a.id == groupIdSelected);
                        setGroupNameSelected({name:groupsListSelected.name})
                        setGroupIdSelected(groupIdSelected)
                    }
                    
                    setLoading(false);
                    if(!error) {
                        setTimeout(() => {
                            setError(false);
                        }, 3000);
                    }
                }).catch((data) => {
                    setError(data?.message);
                    setLoading(false);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }

        if (!error) {
            setTimeout(() => {
                setError(false);
            }, 3000);
        }

    };
    
    return (
        <div className="flex-parent-element"
        >
            {eventsList.length == 0 && zonesList.length == 0 && !loading && loadingPanel}
            {loading && loadingPanel}
            <br />
            <NotificationGroup
                style={{
                    right: 0,
                    bottom: 50,
                    alignItems: "flex-start",
                    flexWrap: "wrap-reverse",
                }}
            >
                <Fade enter={true} exit={true}>
                    {apiMessage && (
                        <Notification
                            type={{ style: "warning", icon: true }}
                            closable={true}
                            onClose={() => setApiMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_call_API_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {commandMessage && (
                        <Notification
                            type={{ style: "warning", icon: true }}
                            closable={true}
                            onClose={() => setCommandMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_command_type_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {actuatorMessage && (
                        <Notification
                            type={{ style: "warning", icon: true }}
                            closable={true}
                            onClose={() => setActuatorMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_actuator_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {removed && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            closable={true}
                            onClose={() => setRemoved(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_removed_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {error && (
                        <Notification
                            type={{ style: "error", icon: true }}
                            closable={true}
                            onClose={() => setError(false)}
                        >
                            <span>{error}</span>
                        </Notification>
                    )}
                    {alarmsFound && (
                        <Notification
                            type={{ style: "error", icon: true }}
                            closable={true}
                            onClose={() => setAlarmsFound(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_alarms_found', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {copiedMessage && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            closable={true}
                            onClose={() => setCopiedMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_copied_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {saved && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            closable={true}
                            onClose={() => setSaved(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_saved_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {updated && (
                        <Notification
                            type={{ style: "success", icon: true }}
                            closable={true}
                            onClose={() => setUpdated(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_updated_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {noZoneFoundMessage && (
                        <Notification
                            type={{ style: "warning", icon: true }}
                            closable={true}
                            onClose={() => setNoZoneFoundMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_no_zone_found_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {noFirstMapMessage && (
                        <Notification
                            type={{ style: "warning", icon: true }}
                            closable={true}
                            onClose={() => setNoFirstMapMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_no_first_map_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                    {noSecondMapMessage && (
                        <Notification
                            type={{ style: "warning", icon: true }}
                            closable={true}
                            onClose={() => setNoSecondMapMessage(false)}
                        >
                            <span>{localizationService.toLanguageString('configuration.rules.subscription_no_second_map_message', 'NOT FOUND')}</span>
                        </Notification>
                    )}
                </Fade>
            </NotificationGroup>

            
            <div 
                style={{
                    display: 'inline-table',
                    padding: '20px',
                    //borderRight: '1px solid #1A8894'
                }}
            >
                {/*{zonesList?.length == 0 && !loading && loadingPanel}*/}
                <div style={{ textAlign:'center', marginBottom:'20px' }}>
                    <p
                        style={{ display:'inline-flex', textAlign: 'center', fontSize: '20px', color: '#1A8893' }}
                    >
                        {localizationService.toLanguageString('configuration.rules.subscription_name', 'NOT FOUND')} ({newSubscription.length})
                    </p>

                    <Button
                        title={localizationService.toLanguageString('configuration.rules.subscription_new', 'NOT FOUND')}
                        themeColor={"primary"}
                        className="plusParam"
                        style={{
                            marginRight: '10px',
                            marginTop: '0px',
                        }}
                        onClick={()=>refreshSubscription()}
                    >
                        <Avatar
                            className="plusParam"
                        >
                            <SvgIcon
                                icon={plusIcon}
                                style={{ margin: '8px' }}
                            />
                        </Avatar>
                    </Button>
                </div>

                <div>
                    <div  
                        style={{ 
                            marginLeft: '30px' 
                        }}
                    >
                        {newSubscription?.map((subscription: any, index: any) => {
                            return (
                                <div 
                                    key={index} 
                                >
                                     
                                    <div 
                                        className="trash-icon"
                                        style={{
                                            float: 'left',
                                            cursor: 'pointer',
                                            alignContent: 'center',
                                            marginRight: '10px'
                                        }}
                                        title={localizationService.toLanguageString('configuration.rules.subscription_remove', 'NOT FOUND')}
                                        onClick={() => removingSubscription(subscription)} 
                                    >
                                        <Avatar 
                                            className="trash-icon"
                                        >
                                            <SvgIcon icon={trashIcon} style={{ verticalAlign: 'baseline', margin: '10px' }} />
                                        </Avatar>
                                    </div>
                                    
                                    <div
                                        className="trash-icon"
                                        style={{
                                            float: 'left',
                                            cursor: 'pointer',
                                            alignContent: 'center',
                                            marginRight: '10px'
                                        }}
                                        onClick={() => copySubscription(subscription)}                                        
                                        title={localizationService.toLanguageString('configuration.rules.subscription_copy', 'NOT FOUND')}    
                                    >
                                        <Avatar 
                                            className="trash-icon"
                                        >
                                            <SvgIcon 
                                                icon={copyIcon} 
                                                style={{ verticalAlign: 'baseline', margin: '10px' }} 
                                            />
                                        </Avatar>
                                    </div>  

                                    <p
                                        className="card-block-registry-group"
                                        ref={(el) => (itemRefs.current[subscription.id] = el)}
                                        style={{
                                            cursor: 'pointer',
                                            marginLeft: '10px',
                                            marginBottom: '0px',
                                            padding: '10px'
                                        }}
                                        onClick={() => loadSubscriptionSelected(subscription)}
                                    >
                                        {subscription.description}
                                    </p>                                  
                                    
                                </div>
                            )
                        })}
                    </div>
                </div>

            </div>

            <div className="flex-right-child-element" 
                style={{ 
                    width: 'auto',
                    background: 'white',
                    flexGrow: 1,
                    borderLeft: '1px solid #1A8894'
                }}
            >
               <div>
                    <SvgIcon icon={exclamationCircleIcon} size="medium" style={{ color: '#198793', marginRight: '5px', marginBottom: '2px', }} />
                    {localizationService.toLanguageString('configuration.rules.subscription_when', 'NOT FOUND')}: <em>{localizationService.toLanguageString('configuration.rules.subscription_event_type', 'NOT FOUND')}</em>
                </div>

                <div style={{ whiteSpace: 'pre' }}>
                    <DropDownList
                       style={{
                            minWidth: "350px",
                            width: "max-content",
                            marginRight: "10px"
                        }}
                        data={eventsList}
                        textField="description"
                        value={eventDescription}
                        onChange={(e: any) => e.value != "" ? onChangeEvent(e) : null}
                    />

                    {/*add/update buttons*/}
                    { retrievedSubscription ?
                        <div 
                            style={{ display: 'inline' }}
                        >
                            <Button
                                title={localizationService.toLanguageString('configuration.rules.subscription_update', 'NOT FOUND')}
                                themeColor={"primary"}
                                className="saveParam"
                                disabled={!isTimeslotSelected ? true : false || (actionIdSelected == 3 || actionIdSelected == 8) && !actuatorSelected ? true : false}
                                onClick={() => updateSubscription(subscriptionId)}
                            >
                                <Avatar
                                    className="saveParam"
                                >
                                    <SvgIcon
                                        icon={saveIcon}
                                        style={{ margin: '8px' }}
                                    />
                                </Avatar>
                            </Button>
                        </div>
                        :
                        // save
                        <Button
                            title={localizationService.toLanguageString('configuration.rules.subscription_save', 'NOT FOUND')}
                            themeColor={"primary"}
                            className="saveParam"
                            disabled={!isTimeslotSelected ? true : false || (actionIdSelected == 3 || actionIdSelected == 8) && !actuatorSelected ? true : false}
                            onClick={saveNewSubscription}
                        >
                            <Avatar
                                className="saveParam"
                            >
                                <SvgIcon
                                    icon={saveIcon}
                                    style={{ margin: '8px' }}
                                />
                            </Avatar>
                        </Button>                        
                    }
                </div>

                {/* device belong to group*/}
                {eventsSelected &&
                    <>
                        <br />
                        <div>
                            <SvgIcon icon={userIcon} size="medium" style={{ color: '#198793', marginBottom: '0px', marginRight: '-12px', padding: '1px' }} />
                            <SvgIcon icon={userIcon} size="medium" style={{ color: '#198793', margin: '2px 2px 4px 2px' }} />
                            <SvgIcon icon={userIcon} size="medium" style={{ color: '#198793', marginBottom: '0px', marginLeft: '-12px', padding: '1px' }} />
                            {localizationService.toLanguageString('configuration.rules.subscription_device_belongs_to_group', 'NOT FOUND')}
                        </div>
                        <DropDownList
                            dataItemKey="id"
                            data={groupsList[0]}
                            textField="name"
                            valueRender={groupRender}
                            style={{
                                width: "350px"
                            }}
                            value={deviceGroupNameSelected}
                            onChange={onDeviceBelongToGroup}
                        />

                    </>
                }

                {/* if group with job */}
                {deviceGroupsSelected && containJobs &&
                    <>
                        <br />
                        <br />
                        <div>
                            <SvgIcon icon={userIcon} size="medium" style={{ color: '#198793', marginBottom: '0px', marginRight: '-12px', padding: '1px' }} />
                            <SvgIcon icon={userIcon} size="medium" style={{ color: '#198793', margin: '2px 2px 4px 2px' }} />
                            <SvgIcon icon={userIcon} size="medium" style={{ color: '#198793', marginBottom: '0px', marginLeft: '-12px', padding: '1px' }} />
                            {localizationService.toLanguageString('configuration.rules.subscription_group_with_jobs', 'NOT FOUND')}
                        </div>
                        <DropDownList
                            data={jobsList?.map((job: any) => {
                                return (
                                    job?.name ?? ''
                                )
                            })}
                            valueRender={jobRender}
                            style={{
                                width: "350px"
                            }}
                            value={jobNameSelected ?? jobsList[0].name}
                            onChange={onJobSelected}
                        />

                    </>
                }

                <br />

                {/*timeslots*/}
                {(containJobs ? jobSelected : deviceGroupsSelected) &&
                    <>
                        <br />

                        <div><SvgIcon icon={clockIcon} size="medium" style={{ marginRight: '5px', marginBottom: '3px' }} />{localizationService.toLanguageString('configuration.rules.subscription_in_timeslot', 'NOT FOUND')}</div>
                        <DropDownList
                            data={timeSlotList}
                            //valueRender={timeslotRender}
                            textField={'range'}
                            style={{
                                width: "350px",
                            }}
                            //value={timeSlotSelected != '' ? timeSlotSelected : timeSlotSelected.range != '' ? timeSlotSelected.range : ''}
                            value={timeSlotSelected ?? ''}
                            onChange={onTimeslotChange}
                        />

                    </>
                }

                {/*device out of range*/}
                {isTimeslotSelected && eventsIdSelected == 4 &&
                    <div
                        style={{
                            width: "370px"
                        }}
                    >
                        <br />

                        <div>
                            <SvgIcon icon={clockArrowRotateIcon} size="medium" style={{ marginRight: '5px', marginBottom: '3px', }} />
                            {localizationService.toLanguageString('configuration.rules.subscription_timeout', 'NOT FOUND')}(s)
                        </div>

                        <div style={{ display: 'flex' }}>
                            <div>
                                {/*<p style={{ fontSize: '10px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_timeout', 'NOT_FOUND')}(s)</p>*/}
                                <TextBox
                                    style={{ width: "165px" }}
                                    value={timeoutValue ?? 0}
                                    onChange={onChangeTimeout}
                                    type='number'
                                    placeholder='0'
                                    min={0}
                                />
                            </div>
                        </div>
                    </div>
                }

                {/*approching device*/}
                {isTimeslotSelected && eventsIdSelected == 5 &&
                    <div
                        style={{
                            width: "370px"
                        }}
                    >
                        <br />

                        <div>
                            {/*<SvgIcon icon={} size="medium" style={{ marginRight: '5px', marginBottom: '3px', }} />*/}
                            {localizationService.toLanguageString('configuration.rules.subscription_considering', 'NOT FOUND')}
                        </div>

                        <div style={{ display: 'flex' }}>
                            <div>
                                <p style={{ fontSize: '10px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_max_distance', 'NOT_FOUND')}(uc)</p>
                                <TextBox
                                    style={{ width: "165px" }}
                                    value={maxDistance ?? 0}
                                    onChange={onChangeMaxDistance}
                                    type='number'
                                    placeholder='0'
                                    min={0}
                                />
                            </div>
                        </div>
                        <br />
                    </div>
                }

                {/*device battery low*/}
                {isTimeslotSelected && eventsIdSelected == 12 &&
                    <div
                        style={{
                            width: "370px"
                        }}
                    >
                        <br />
                        <br />

                        <p style={{ width: '300px' }}>
                            {/*<SvgIcon icon={batteryIcon} size="medium" style={{ color: '#198793', marginRight: '5px', marginBottom: '2px', }} />*/}
                            {localizationService.toLanguageString('configuration.rules.subscription_battery', 'NOT FOUND')}
                        </p>

                        <div style={{ display: 'flex' }}>
                            <Slider
                                // vertical={true}
                                min={0}
                                max={100}
                                step={1}
                                value={batteryValue}
                                onChange={onChangeBatteryValue}
                            >
                                {defaultBatteryValue.map((value: any, id: any) => (
                                    <SliderLabel
                                        //title={value.toString() + ' ' + localizationService.toLanguageString('configuration.rules.subscription_battery', 'NOT FOUND')}
                                        key={id}
                                        position={value}
                                        onClick={() => {
                                            setBatteryValue(value);
                                        }}
                                    >
                                        {value.toString() + '%'}
                                    </SliderLabel>
                                ))
                                }
                            </Slider>
                            <p style={{ width: '50px', marginLeft: '10px' }}>{Math.trunc(batteryValue) + '%'}</p>
                        </div>
                        <br />
                    </div>
                }

                {/* device close/far to/from position */}
                {isTimeslotSelected && (eventsIdSelected == 32 || eventsIdSelected == 33) && 
                    <div
                        style={{
                            display: 'inline',
                            width: "400px",
                            height: `${showMap ? '200px' : ' 70px'}`,
                            marginTop: '20px',
                            marginBottom: `${showMap ? '130px' : ' 0px'}`,
                        }}
                    >
                        <div
                            style={{
                                marginTop: '20px',
                                marginBottom: '20px'
                            }}
                        >
                            {localizationService.toLanguageString('configuration.rules.subscription_respect_to_position', 'NOT FOUND')}: [ <b>x: {currentPositionX}</b> | <b>y: {currentPositionY}</b> | <b>z: {currentPositionElevation}</b> ]
                        </div>
                        <DropDownList
                            style={{
                                width: "200px",
                                marginBottom: '20px',
                            }}
                            data={mapsList}
                            textField="name"
                            value={mapNameSelected} 
                            onChange={onChangeMap}
                        />

                        { showMap && 

                            <div
                                className="flex-left-child-element canvas-container-subscription"
                                style={{ display: `${mapClickableSelected ? 'inline-table' : 'none'}` }}
                            >                           
                                {isMapGeoreferenced == 0  ?
                                    <TransformWrapper
                                        initialPositionX={0}
                                        initialPositionY={0}
                                        minScale={0.7}
                                        centerOnInit={true}
                                        centerZoomedOut={true}
                                        limitToBounds={true}
                                        smooth={true}
                                    >
                                        {({ zoomIn, zoomOut, resetTransform, centerView, zoomToElement, ...rest }) => (
                                            <div id='firstMapCanvas'>
                                                <Controls />
                                                <TransformComponent
                                                    wrapperStyle={{
                                                        width: '100%',
                                                        height: '100%'
                                                    }}
                                                    contentStyle={{
                                                        width: '600px',
                                                        height: '300px',
                                                    }}
                                                >
                                                    <canvas
                                                        ref={firstMapCanvas}
                                                        className="mapCanvasSubscription"
                                                        width={600}
                                                        height={300}
                                                    />
                                                    <canvas
                                                        ref={firstPinCanvas}
                                                        className="firstPinCanvas"
                                                        width={600}
                                                        height={300}
                                                    />
                                                </TransformComponent>
                                            </div>
                                        )}
                                    </TransformWrapper>
                                    :
                                        showMap && isMapGeoreferenced == 1 ? 
                                        <AzureMapComponent map={mapClickableSelected} zone={zoneSelected} subscription={true} />
                                    :
                                    null
                            }
                            </div>
                        }
                    </div>
                }

                {/*custom info value changed*/}
                {isTimeslotSelected && eventsIdSelected == 49 &&
                    <div
                        style={{
                            width: "370px"
                        }}
                    >
                        <br />

                        <p style={{ width: '300px' }}>
                            <SvgIcon icon={cssIcon} size="medium" style={{ marginRight: '5px', marginBottom: '3px' }} />
                            {localizationService.toLanguageString('configuration.rules.subscription_status_detail', 'NOT FOUND')}
                        </p>

                        <div style={{ display: 'flex' }}>
                            <div>
                                <p style={{ fontSize: '10px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_first_min_states', 'NOT_FOUND')}</p>
                                <TextBox
                                    style={{ width: "165px" }}
                                    value={firstMinStates ?? ''}
                                    onChange={onChangeFirstMinStates}
                                    placeholder=''
                                />
                            </div>
                            <div style={{ marginLeft: '20px' }}>
                                <p style={{ fontSize: '10px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_first_max_states', 'NOT_FOUND')}</p>
                                <TextBox
                                    style={{ width: "165px" }}
                                    value={firstMaxStates ?? ''}
                                    onChange={onChangeFirstMaxStates}
                                    placeholder=''
                                />
                            </div>
                        </div>
                        <br />
                        <div style={{ display: 'flex' }}>
                            <div>
                                <p style={{ fontSize: '10px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_second_min_states', 'NOT_FOUND')}</p>
                                <TextBox
                                    style={{ width: "165px" }}
                                    value={secondMinStates ?? ''}
                                    onChange={onChangeSecondMinStates}
                                    placeholder=''
                                />
                            </div>
                            <div style={{ marginLeft: '20px' }}>
                                <p style={{ fontSize: '10px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_second_max_states', 'NOT_FOUND')}</p>
                                <TextBox
                                    style={{ width: "165px" }}
                                    value={secondMaxStates ?? ''}
                                    onChange={onChangeSecondMaxStates}
                                    placeholder=''
                                />
                            </div>
                        </div>
                        <br />
                        <div style={{ display: 'flex' }}>
                            <div>
                                <p style={{ fontSize: '10px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_property_name', 'NOT_FOUND')}</p>
                                <TextBox
                                    style={{ width: "165px" }}
                                    value={propertyName ?? ''}
                                    onChange={onChangePropertyName}
                                    placeholder=''
                                />
                            </div>
                            <div style={{ marginLeft: '20px' }}>
                                <p style={{ fontSize: '10px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_direction_states', 'NOT_FOUND')}</p>
                                <DropDownList
                                    style={{
                                        width: "165px",
                                    }}
                                    data={directionList.data}
                                    textField="name"
                                    value={directionNameSelected}
                                    onChange={onChangeStateDirection}
                                />
                            </div>
                        </div>
                    </div>
                }

                {/*zones*/}
                {/*{loading && loadingPanel}*/}
                {isTimeslotSelected && (eventsIdSelected != 7 && eventsIdSelected != 8 && eventsIdSelected != 4 && eventsIdSelected != 5 && eventsIdSelected != 12 && eventsIdSelected != 32 && eventsIdSelected != 33 && eventsIdSelected != 49) &&
                    <>
                        <br />
                        <br />
                        <div>
                            <SvgIcon icon={globeIcon} size="medium" style={{ marginRight: '5px', marginBottom: '3px' }} />
                            {localizationService.toLanguageString('configuration.rules.subscription_referring_zone', 'NOT FOUND')}
                        </div>
                        <DropDownList
                            style={{
                                width: "350px",
                                marginBottom: '20px',
                            }}
                            data={zonesList}
                            textField="name"         
                            value={zoneNameSelected}       
                            valueRender={zoneRender}
                            onChange={onChangeZones}
                        />

                        <br />

                        { isZoneSelected &&

                        <div
                            className="flex-left-child-element canvas-container-subscription"
                            style={{ display: `${zoneIdSelected ? 'inline-table' : 'none'}` }}
                        >
                            { isMapGeoreferenced == 0 ?
                                <TransformWrapper
                                    initialScale={1}
                                    initialPositionX={0}
                                    initialPositionY={0}
                                    minScale={1}
                                    //centerOnInit={true}
                                    centerZoomedOut={true}
                                    limitToBounds={true}
                                    smooth={true}
                                >
                                    {({ zoomIn, zoomOut, resetTransform, centerView, zoomToElement, ...rest }) => (
                                        <div id='firstMapCanvas'>
                                            <Controls />
                                            <TransformComponent
                                                wrapperStyle={{
                                                    width: '100%',
                                                    height: '100%'
                                                }}
                                                contentStyle={{
                                                    width: '600px',
                                                    height: '300px',
                                                }}
                                            >
                                                <canvas
                                                    ref={firstMapCanvas}
                                                    className="mapCanvasSubscription"
                                                    width={600}
                                                    height={300}
                                                />
                                                <canvas
                                                    ref={zoneCanvas}
                                                    className="zoneCanvas"
                                                    width={600}
                                                    height={300}
                                                />
                                            </TransformComponent>
                                        </div>
                                    )}
                                </TransformWrapper>
                                :
                                <AzureMapComponent map={mapClickableSelected} zone={zoneSelected} subscription={true} />
                            }
                        </div>
                        }

                        {/*max devices*/}
                        {isTimeslotSelected && eventsIdSelected == 25 &&
                            <div
                                style={{
                                    width: "370px"
                                }}
                            >
                                <br />

                                <div style={{ width: '300px' }}>
                                    {localizationService.toLanguageString('configuration.rules.subscription_max_devices', 'NOT FOUND')}
                                </div>

                                <div>
                                    {/*<p style={{ fontSize: '10px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_max_devices', 'NOT_FOUND')}</p>*/}
                                    <TextBox
                                        style={{ width: "235px" }}
                                        value={maxDevices ?? 0}
                                        onChange={onChangeMaxDevices}
                                        type='number'
                                        placeholder='0'
                                        min={0}
                                    />
                                </div>
                            </div>
                        }

                        {/*min devices*/}
                        {isTimeslotSelected && eventsIdSelected == 26 &&
                            <div
                                style={{
                                    width: "370px"
                                }}
                            >
                                <br />

                                <div style={{ width: '300px' }}>
                                    {localizationService.toLanguageString('configuration.rules.subscription_min_devices', 'NOT FOUND')}
                                </div>

                                <div>
                                    <TextBox
                                        style={{ width: "235px" }}
                                        value={minDevices ?? 0}
                                        onChange={onChangeMinDevices}
                                        type='number'
                                        placeholder='0'
                                        min={0}
                                    />
                                </div>
                            </div>
                        }
                        <br />
                    </>
                }

                {/*execute actions*/}
                {isTimeslotSelected && zoneNameSelected &&
                    <div
                        style={{
                            marginTop: '20px'
                        }}
                    >
                        <div>
                            <SvgIcon icon={playSmIcon} size="medium" style={{ color: '#198793', marginRight: '5px', marginBottom: '2px', }} />
                            {localizationService.toLanguageString('configuration.rules.subscription_execute_action', 'NOT FOUND')}
                        </div>
                        <DropDownList
                            //defaultItem={localizationService.toLanguageString('configuration.rules.subscription_execute_action', 'NOT FOUND')}
                            style={{
                                width: "350px",
                            }}
                            data={actionsList}
                            textField={'action'}
                            value={actionSelected ?? actionSelected.action}
                            onChange={onChangeAction}
                        />

                    </div>
                }

                <br />

                {/*miscellaneous*/}
                {isTimeslotSelected && action && miscellaneous &&
                    <>

                        {/*actuators & relay channels*/}
                        {
                            actionIdSelected == 3 &&
                            <div
                                style={{
                                    width: "680px",
                                    marginRight: '20px'
                                }}
                            >
                                <p style={{ width: '300px' }}>
                                    <SvgIcon icon={sparklesIcon} size="medium" style={{ color: '#198793', marginRight: '5px', marginBottom: '2px', }} />
                                    {localizationService.toLanguageString('configuration.rules.subscription_action_on_relays_driver', 'NOT FOUND')}:
                                </p>

                                
                                <div style={{ display: 'flex' }}>

                                    {/*actuatorSelected*/}
                                    <div style={{ display: 'inline' }}>
                                        <div>{localizationService.toLanguageString('configuration.rules.subscription_select_actuator', 'NOT FOUND')}</div>
                                        <DropDownList
                                            //defaultItem={localizationService.toLanguageString('configuration.rules.subscription_select_actuator', 'NOT FOUND')}
                                            style={{
                                                width: "200px",
                                                marginRight: '20px'
                                            }}                                            
                                            data={actionHandlersList}
                                            textField={'name'}
                                            value={actuatorSelected ?? ''}
                                            onChange={onChangeActuator}
                                        />
                                    </div>

                                    {/*channelNameSelected*/}
                                    <div style={{ display: 'inline' }}>
                                        <div>{localizationService.toLanguageString('configuration.rules.subscription_channels', 'NOT FOUND')}</div>
                                        <DropDownList
                                            style={{
                                                width: "170px",
                                            }}
                                            data={channelsDropdownList}
                                            textField={'name'}
                                            //value={defaultChannel != '' ?? channelNameSelected}
                                            value={channelNameSelected}
                                            onChange={onChangeChannel}
                                        />
                                    </div>

                                    <div
                                        style={{ display: 'inline-grid' }}
                                    >
                                        {channelRelaysList?.map((channelSelected: any, index: any) => {
                                            return (
                                                <div
                                                    key={index}
                                                    //data-index={channelSelected.name} 
                                                    style={{ display: 'inline-flex' }}
                                                >
                                                    <div
                                                        className="col-1"
                                                        style={{ maxWidth: '14%', cursor: 'pointer' }}
                                                        onClick={() => removeChannelRelays(channelSelected.name, index)}
                                                    >
                                                        <Avatar style={{ background: "#018CA5" }}>
                                                            <SvgIcon icon={trashIcon} style={{ verticalAlign: 'baseline', margin: '10px' }} />
                                                        </Avatar>
                                                    </div>
                                                    <div className="col-6" style={{ margin: '5px 0px 0px 20px' }}>
                                                        <p>{channelSelected.name}</p>
                                                    </div>
                                                    <Switch
                                                        onChange={(e: any) => handleToggleChannelSelected(e, channelSelected.name)}
                                                        checked={channelSelected.checked ?? channelSelected}
                                                    />
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>


                                <br />
                            </div>
                        }

                        {/*actuators & channels relay multi*/}
                        {
                            actionIdSelected == 8 &&
                            <div
                                style={{
                                    width: "750px"
                                }}
                            >

                                <p style={{ width: '300px' }}>
                                    <SvgIcon icon={sparklesIcon} size="medium" style={{ color: '#198793', marginRight: '5px', marginBottom: '2px', }} />
                                    {localizationService.toLanguageString('configuration.rules.subscription_action_on_multiple_relay_driver', 'NOT FOUND')}
                                </p>

                                <div>
                                    {localizationService.toLanguageString('configuration.rules.subscription_select_actuator', 'NOT FOUND')}
                                </div>
                                <DropDownList
                                    //defaultItem={localizationService.toLanguageString('configuration.rules.subscription_select_actuator', 'NOT FOUND')}
                                    style={{
                                        width: "200px",
                                        marginRight: '20px'
                                    }}
                                    data={actionHandlersList}
                                    textField={'name'}
                                    value={actuatorSelected ?? ''}
                                    onChange={onChangeActuator}
                                />

                                <br />
                                <br />

                                <div style={{ display: 'inline-block' }}>
                                    <div>{localizationService.toLanguageString('configuration.rules.subscription_channels', 'NOT FOUND')}</div>
                                    <DropDownList
                                        style={{
                                            width: "170px",
                                        }}
                                        data={multiChannelsDropdownList}
                                        textField={'name'}
                                        value={multiChannelNameSelected}
                                        onChange={
                                            (e: any) => e.value != localizationService.toLanguageString('configuration.rules.subscription_channels', 'NOT FOUND')
                                                ? onChangeMultipleChannel(e)
                                                : null
                                        }
                                    />
                                </div>
                                <Button
                                    disabled={true}
                                    style={{ background: 'transparent', border: 'none', cursor: 'pointer', boxShadow: 'none' }}
                                    onClick={onAddMultiChannel}
                                >
                                    <SvgIcon icon={plusCircleIcon} size="xxlarge" style={{ color: '#018CA5' }} />
                                </Button>

                                <div style={{ display: 'inline-block', margin: '0px 0px 0px 20px' }}>
                                    <Checkbox
                                        label={localizationService.toLanguageString('configuration.rules.subscription_initial_condition', 'NOT_FOUND')}
                                        checked={initialCondition}
                                        onChange={handleInitialCondition}
                                    />
                                    <DropDownList
                                        style={{
                                            width: "170px",
                                            marginRight: '20px'
                                        }}
                                        data={multiChannelsDropdownList}
                                        textField={'name'}
                                        value={initialChannel}
                                        disabled={!initialCondition}
                                        onChange={(e: any) => onChangeInitialChannel(e)}
                                    />
                                    <Switch
                                        onChange={(e: any) => handleToggleInitialChannelSelected(e)}
                                        disabled={!initialCondition}
                                        checked={checkedInitialChannel.checked ?? checkedInitialChannel}
                                    />
                                </div>

                                <div
                                    style={{ display: 'inline', height: '70px' }}>
                                    {multiChannelSelectedList?.map((channelSelected: any, index: any) => {
                                        return (
                                            <div 
                                                key={index} 
                                                style={{ display: 'flex', alignItems: 'end', marginTop: '10px' }}
                                            >
                                                <div
                                                    className=""
                                                    style={{ maxWidth: '14%', cursor: 'pointer' }}
                                                    onClick={ () => removeMultiChannelRelays(channelSelected.name, index)}
                                                >
                                                    <Avatar style={{ background: "#018CA5" }}>
                                                        <SvgIcon icon={trashIcon} style={{ verticalAlign: 'baseline', margin: '10px' }} />
                                                    </Avatar>
                                                </div>
                                                <div className="col-2" style={{ margin: '5px 0px 0px 0px', height: '30px' }}>
                                                    <p>{channelSelected.name}</p>
                                                </div>
                                                <Switch
                                                    onChange={(e: any) => handleToggleMultiChannelSelected(e, channelSelected, index)}
                                                    checked={channelSelected.checked ?? channelSelected}
                                                />

                                                {/*delay timeout*/}
                                                <div style={{ marginLeft: '20px' }}>
                                                    <p style={{ fontSize: '12px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_delay_timeout(ms)', 'NOT_FOUND')}</p>
                                                    <TextBox
                                                        style={{ width: "100px" }}
                                                        value={channelSelected.delay ?? delayChannel[index]}
                                                        onChange={(e:any) => handleChangeDelayChannel(e, index)}
                                                        placeholder='0'
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })}

                                </div>
                                <br />
                            </div>
                        }

                        {/*command type*/}
                        {
                            actionIdSelected == 4 &&
                            <div>
                                <div>{localizationService.toLanguageString('configuration.rules.subscription_command_type', 'NOT FOUND')}</div>
                                <DropDownList
                                    style={{
                                        width: "350px",
                                        marginRight: '20px'
                                    }}
                                    data={commandsList}
                                    textField={'command'}
                                    onChange={onChangeCommandType}
                                />
                            </div>
                        }

                        {/*call API*/}
                        {
                            actionIdSelected == 9 &&
                            <div>
                                <div>{localizationService.toLanguageString('configuration.rules.subscription_API', 'NOT FOUND')}</div>
                                <DropDownList
                                    defaultItem={localizationService.toLanguageString('configuration.rules.subscription_call_API', 'NOT FOUND')}
                                    style={{
                                        width: "200px",
                                        marginRight: '20px'
                                    }}
                                    data={apiList}
                                    textField={'name'}
                                    value={apiNameSelected ?? apiNameSelected?.name}
                                    onChange={onChangeCallAPI}
                                />

                            </div>
                        }

                        {/*move device maps */}
                        {
                            actionIdSelected == 10 &&
                            <div
                                style={{
                                    display: 'inline',
                                    width: '350px',
                                    height: `${showMoveDeviceMap ? '170px' : ' 70px'}`,
                                    marginTop: '10px',
                                    marginBottom: `${showMoveDeviceMap ? '30px' : ' 0px'}`,
                                }}
                            >
                                <div>{localizationService.toLanguageString('configuration.rules.subscription_move_to', 'NOT FOUND')}: [ <b>x: {currentPositionMovedDeviceX}</b> | <b>y: {currentPositionMovedDeviceY}</b> | <b>z: {currentPositionMovedDeviceElevation}</b> ]</div>
                                <DropDownList
                                    style={{
                                        width: '200px',
                                        marginBottom: '20px',
                                    }}
                                    data={mapsList}
                                    textField={'name'}
                                    value={mapNameMoved}
                                    onChange={onChangeMapMoveDevice}
                                />

                                <br />

                                <div
                                    className="flex-left-child-element canvas-container-subscription"
                                    style={{ display: `${mapMoveDeviceClickableSelected ? 'inline-table' : 'none'}` }}
                                >
                                    { isSecondMapGeoreferenced == 0 ?
                                        <TransformWrapper
                                            initialScale={0.8}
                                            initialPositionX={0}
                                            initialPositionY={0}
                                            minScale={0.5}
                                            centerOnInit={true}
                                            centerZoomedOut={true}
                                            limitToBounds={true}
                                            smooth={true}
                                        >
                                            {({ zoomIn, zoomOut, resetTransform, centerView, zoomToElement, ...rest }) => (
                                                <div id='secondMapCanvas'>
                                                    <Controls />
                                                    <TransformComponent
                                                        wrapperStyle={{
                                                            width: '100%',
                                                            height: '100%'
                                                        }}
                                                        contentStyle={{
                                                            width: '500px',
                                                            height: '250px',
                                                        }}
                                                    >
                                                        <canvas
                                                            ref={secondMapCanvas}
                                                            className="mapCanvasSubscriptionMoveDevice"
                                                            width={600}
                                                            height={450}
                                                        />
                                                        <canvas
                                                            ref={secondPinCanvas}
                                                            className="secondPinCanvas"
                                                            width={600}
                                                            height={450}
                                                        />
                                                    </TransformComponent>
                                                </div>
                                            )}
                                        </TransformWrapper>
                                    :
                                        //<SecondMapContainer />
                                        <AzureMapComponent map={mapClickableSelected} zone={zoneSelected} subscription={true} />
                                    }
                                </div>
                            </div>
                        }

                        {/*change group*/}
                        {
                            actionIdSelected == 11 &&
                            <>
                                <div>{localizationService.toLanguageString('configuration.rules.subscription_change_group', 'NOT FOUND')}</div>
                                <DropDownList
                                    data={groupsList[0]}
                                    textField="name"
                                    valueRender={groupRender}
                                    style={{
                                        width: "350px"
                                    }}
                                    value={groupNameSelected}
                                    onChange={onChangeGroup}
                                />
                                <br />

                            </>
                        }

                        <br />

                        {/*miscellaneous*/}
                        <div style={{ display: 'block' }}>
                            <div>{localizationService.toLanguageString('configuration.rules.subscription_miscellaneous', 'NOT_FOUND')}</div>

                            {/*timeoutSpam*/}
                            <p style={{ fontSize: '12px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_spam_timeout(ms)', 'NOT_FOUND')}</p>
                            <TextBox
                                style={{ width: "350px" }}
                                value={timeoutSpam ?? ''}
                                onChange={handleChangeTimeoutSpam}
                                placeholder='0'
                            />

                            <br />
                            <br />

                            {/*autoAck*/}
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Checkbox
                                    label={localizationService.toLanguageString('configuration.rules.subscription_autoAck', 'NOT_FOUND')}
                                    defaultChecked={autoAck}
                                    onChange={handleAutoAck}
                                />

                                <div style={{ marginLeft: '30px', visibility: `${autoAck ? 'visible' : 'hidden'}` }}>
                                    <p style={{ fontSize: '10px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_autoAck_timeout(ms)', 'NOT_FOUND')}</p>
                                    <TextBox
                                        style={{ width: "235px" }}
                                        value={autoAckTimeout ?? ''}
                                        onChange={handleChangeAutoAckTimeout}
                                        type='number'
                                        placeholder='1000'
                                        min={1000}
                                    />
                                </div>

                            </div>
                        </div>
                        
                        {
                            //actionIdSelected != 10 ?
                            //    <div style={{ display: 'block' }}>
                            //        <div>{localizationService.toLanguageString('configuration.rules.subscription_miscellaneous', 'NOT_FOUND')}</div>

                            //        {/*timeoutSpam*/}
                            //        <p style={{ fontSize: '12px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_spam_timeout(ms)', 'NOT_FOUND')}</p>
                            //        <TextBox
                            //            style={{ width: "350px" }}
                            //            value={timeoutSpam ?? ''}
                            //            onChange={handleChangeTimeoutSpam}
                            //            placeholder='0'
                            //        />

                            //        <br />
                            //        <br />

                            //        {/*autoAck*/}
                            //        <div style={{ display: 'flex', alignItems: 'center' }}>
                            //            <Checkbox
                            //                label={localizationService.toLanguageString('configuration.rules.subscription_autoAck', 'NOT_FOUND')}
                            //                defaultChecked={autoAck}
                            //                onChange={handleAutoAck}
                            //            />

                            //            <div style={{ marginLeft: '30px', visibility: `${autoAck ? 'visible' : 'hidden'}` }}>
                            //                <p style={{ fontSize: '10px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_autoAck_timeout(ms)', 'NOT_FOUND')}</p>
                            //                <TextBox
                            //                    style={{ width: "235px" }}
                            //                    value={autoAckTimeout ?? ''}
                            //                    onChange={handleChangeAutoAckTimeout}
                            //                    type='number'
                            //                    placeholder='1000'
                            //                    min={1000}
                            //                />
                            //            </div>

                            //        </div>
                            //    </div>
                            //:
                            //actionIdSelected == 10 && mapMoveDeviceClickableSelected ?
                            //    <div style={{ display: 'block', marginTop: '30px' }}>
                            //        <div>{localizationService.toLanguageString('configuration.rules.subscription_miscellaneous', 'NOT_FOUND')}</div>

                            //        {/*timeoutSpam*/}
                            //        <p style={{ fontSize: '12px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_spam_timeout(ms)', 'NOT_FOUND')}</p>
                            //        <TextBox
                            //            style={{ width: "350px" }}
                            //            value={timeoutSpam != '' ? timeoutSpam : ''}
                            //            onChange={handleChangeTimeoutSpam}
                            //            placeholder='0'
                            //        />

                            //        <br />
                            //        <br />

                            //        {/*autoAck*/}
                            //        <div style={{ display: 'flex', alignItems: 'center' }}>
                            //            <Checkbox
                            //                label={localizationService.toLanguageString('configuration.rules.subscription_autoAck', 'NOT_FOUND')}
                            //                defaultChecked={autoAck}
                            //                onChange={handleAutoAck}
                            //            />

                            //            <div style={{ marginLeft: '30px', visibility: `${autoAck ? 'visible' : 'hidden'}` }}>
                            //                <p style={{ fontSize: '10px', margin: '0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_autoAck_timeout(ms)', 'NOT_FOUND')}</p>
                            //                <TextBox
                            //                    defaultValue={1000}
                            //                    style={{ width: "235px" }}
                            //                    value={autoAckTimeout ?? ''}
                            //                    onChange={handleChangeAutoAckTimeout}
                            //                    type='number'
                            //                    placeholder='1000'
                            //                    min={1000}
                            //                />
                            //            </div>

                            //        </div>
                            //    </div>
                            //:
                            //null
                        }

                        <br />
                        <br />
                    </>
                }

                <br />
            </div>
            {showPopupDeleteSubscription &&
                <Dialog
                    title={localizationService.toLanguageString('configuration.rules.remove_subscription', 'NOT_FOUND') }
                    onClose={()=>setShowPopupDeleteSubscription(!showPopupDeleteSubscription)}
                >
                    <p style={{width:'400px', fontSize: '20px', margin: '0px' }}>
                        {localizationService.toLanguageString('configuration.rules.deleting_subscription_first', 'NOT_FOUND')}
                        {alarmConnected}
                        {localizationService.toLanguageString('configuration.rules.deleting_subscription_second', 'NOT_FOUND')}
                        <br />
                        {localizationService.toLanguageString('configuration.rules.deleting_subscription_continue', 'NOT_FOUND')}
                    </p>
                    <button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                        style={{
                        margin: '10px',
                        width: '80px'
                        }}
                        onClick={()=>setShowPopupDeleteSubscription(!showPopupDeleteSubscription)}
                    >
                        No
                    </button>
                    <button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                        style={{
                        margin: '10px',
                        width: '80px'
                        }}
                        onClick={()=>removeSubscription(subscriptionToDelete)}
                    >
                        {localizationService.toLanguageString('alarms.yes', 'NOT_FOUND')}
                    </button>
                </Dialog>                
            }
        </div >
    )
}

